if typeof($) == 'undefined' and typeof(jQuery) != 'undefined'
  $ = jQuery

window.calc_time_spend = (_start,_end)->
  _t = (_end-_start)
  sec = 0
  min = 0
  hour = 0
  day = 0
  if _t < 60
    sec = Math.floor(_t)
  else
    min = Math.floor(_t / 60.0)
    sec = Math.ceil(_t - (min * 60))
    if min > 59
      hour = Math.floor(min / 60)
      min = min - Math.floor(hour * 60)
      if hour > 23
        day = Math.floor(hour / 24)
        hour = hour - Math.floor(day * 24)
  year = 0
  month = 0
  if day > 29
    month = Math.floor(day / 30)
    day = day - Math.floor(month * 30)
    if month > 11
      year = Math.floor(month / 12)
      month = month - Math.floor(year * 12)
  ret = []
  ret.push year+" anni" if year > 0
  ret.push month+" mesi" if month > 0
  ret.push day+" giorni" if day > 0
  ret.push hour+" ore" if hour > 0
  ret.push min+" minuti" if min > 0
  ret.push sec+" secondi" if sec > 0 or (day+hour+min) == 0
  ret.join(' ')

window.merge_objects = (obj1,obj2)->
  obj3 = {}
  for attrname of obj1
    obj3[attrname] = obj1[attrname]
  for attrname of obj2
    obj3[attrname] = obj2[attrname]
  obj3

window.params_from_url = (url)->
  params = {}
  splitted_url = url.split('#')
  splitted_url = splitted_url[0].split('?')
  return params if splitted_url.length == 1 or splitted_url[1] == ''
  string_params = splitted_url[1]
  if string_params.match(/&/)
    string_params = string_params.substring(1, string_params.length) if string_params.match(/^&/)
    string_params = string_params.replace(/&/g,"=")
  split_params_get = string_params.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      if param.match(/%5B%5D/)
        _param = param.replace('%5B%5D','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else if param.match(/\[\]/)
        _param = param.replace('[]','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else
        params[param] = split_params_get[i+1]
    else return
  params

window.params_get = params_from_url(document.location.href)

window.add_params_to_url = (url, params)->
  final_url = null
  splitted_url = url.split('?')
  params_url = params_from_url(url)
  if typeof params == 'object'
    params_url = merge_objects(params_url, params)
  else if typeof params == 'string'
    _params = params_from_url("?"+params)
    params_url = merge_objects(params_url, _params)
  all_params = []
  $.each params_url, (k,v)->
    if typeof v == 'object'
      $.each v, (k2,v2)->
        all_params.push k+"[]="+v2
    else
      all_params.push k+"="+v
  if all_params.length > 0
    new_url = splitted_url[0]+"?"+all_params.join('&')
  else
    new_url = splitted_url[0]
  new_url

window.remove_params_from_url = (url, params)->
  base_url = url.split('?')[0]
  url_params = params_from_url(url)
  $.each params, (i,param)->
    delete url_params[param]
  add_params_to_url(base_url, url_params)

# stickyFooter = ->
#   fh = $('#footer').outerHeight()
#   $('#all-content-page').css
#     paddingBottom: fh

window.check_user_menu = ->
  if $('#top-user .info .menu').length > 0
    if $(document).width() < 955
      $('#top-user .info').removeClass('desktop').addClass('mobile')
    else
      $('#top-user .info').removeClass('mobile').addClass('desktop')
      $('#top-user .info .menu-mobile').removeClass('open')
  else
    if $(document).width() < 768
      $('#top-user .info').removeClass('desktop').addClass('mobile')
    else
      $('#top-user .info').removeClass('mobile').addClass('desktop')
      $('#top-user .info .menu-mobile').removeClass('open')

change_onoff = (element, final_trigger=true) ->
  real_input = element.prev("input[type=checkbox]")
  wrapper = element.find(".ta-onoff-wrapper")
  if real_input.is ":checked"
    wrapper.removeClass('checked')
    real_input.prop('checked', false)
  else
    wrapper.addClass('checked')
    real_input.prop('checked', true)
  if final_trigger
    real_input.trigger 'change'

submitIubendaForm = (j_form)->
  subject_id = j_form.find("input[data-cons-id]").val()
  _iub.cons.submit
    form:
      selector: j_form[0] # il selettore del form da cui rilevare i dati
    consent:
      subject:
        id: subject_id
      legal_notices: [
        "identifier": "privacy_policy"
        "version": "2"
      ]
  .success (response)->
    $.ajax
      url: '/wp-content/plugins/request_api_demo.php'
      type: 'POST'
      data:
        api_url: window.demo_url+"api/iubenda/update_subject"
        email: subject_id
        email_confirmation: ''
      complete: ->
        j_form.trigger('ta:iubenda_success')
  .error (response)->
    j_form.trigger('ta:iubenda_error')

fixGridColumns = ->
  ww = $(window).width()
  if ww > 1120
    $('.flex-content > div[data-columns="4"]').removeClass('columns1 columns2 columns3').addClass('columns4')
    $('.flex-content > div[data-columns="3"]').removeClass('columns1 columns2').addClass('columns3')
    $('.flex-content > div[data-columns="2"]').removeClass('columns1').addClass('columns2')
  else if ww > 990
    $('.flex-content > div[data-columns="4"]').removeClass('columns1 columns2 columns4').addClass('columns3')
    $('.flex-content > div[data-columns="3"]').removeClass('columns1 columns2').addClass('columns3')
    $('.flex-content > div[data-columns="2"]').removeClass('columns1').addClass('columns2')
  else if ww > 782
    $('.flex-content > div[data-columns="4"]').removeClass('columns1 columns3 columns4').addClass('columns2')
    $('.flex-content > div[data-columns="3"]').removeClass('columns1 columns3').addClass('columns2')
    $('.flex-content > div[data-columns="2"]').removeClass('columns1').addClass('columns2')
  else
    $('.flex-content > div[data-columns="4"]').removeClass('columns2 columns3 columns4').addClass('columns1')
    $('.flex-content > div[data-columns="3"]').removeClass('columns2 columns3').addClass('columns1')
    $('.flex-content > div[data-columns="2"]').removeClass('columns2').addClass('columns1')
  $('.flex-content > div[data-columns]').addClass('show')

saveClickSearchResult = (desc, link, target, box)->
  $('#ta-ajax-overlay').removeClass('hidden')
  $.ajax
    url: '/wp-admin/admin-ajax.php'
    type: 'POST'
    dataType: "JSON"
    data:
      action: 'ta_user_search'
      term: $('header #navbarSupportedContent .search-form .form-search input').val()
      timestamp: $('#content-forum').data().kt
      desc: desc
      url: link
    success: (response, status, xhr)->
      console.log 'Ricerca salvata'
      if target == "_blank"
        # Click su risultato ricerca del blog da app
        if box.hasClass('ta-topic search ta-blog')
          document.location = link
        else
          window.open(link, "_blank")
      else
        if box.hasClass('ta-topic')
          loadTopicAjax(box)
        else
          document.location = link

window.ta_search = (args={})->
  defatuls = {
    search: null,
    post_type: 'topic',
    current_page: 1,
    element: '#pills-topic',
    total_pages: 1,
    remove_overlay: false
  }
  args = $.extend({}, defatuls, args)
  args.search = $('header .search-form input.search-input').val() unless args.search
  url = if args.post_type == 'tablog' then ta_blog_url+'/wp-content/themes/teamartist_v3/ta_search.php' else '/wp-content/themes/socialv-child/ta_search.php'
  if args.search.length >= 3
    forum_ids = $('#content-forum').data().forumIds.split(',')
    search_forum_id = $('#content-forum').data().searchForumId
    per_page = $('#content-forum').data().perPage
    $.ajax
      url: url
      type: 'POST'
      data:
        search: args.search
        forum_ids: forum_ids
        search_forum_id: search_forum_id
        post_type: args.post_type
        current_page: args.current_page
        per_page: per_page
        total_pages: args.total_pages
        kt: $('#content-forum').data().kt
        is_app: ($('body.in-canvas-app').length > 0)
      complete: ->
        if args.remove_overlay
          $('#total-overlay').addClass('hidden')
      error: ->
        console.log arguments
      success: (response, status, xhr)->
        $(args.element).html response
        # Fix risultati e numero di pagine per i risultati del blog
        if args.post_type == 'tablog' or args.total_pages == 0
          total_results = $(args.element).find('> ul').data().totalResults
          total_pages = $(args.element).find('> ul').data().totalPages
          tab_id = '#'+$(args.element).attr('id')+'-tab'
          tab = $(tab_id)
          if total_results == 0
            tab.parent().remove()
            $(args.element).remove()
          else
            tab.data().totalResults = total_results
            tab.data().totalPages = total_pages
            tab.attr("data-total-results", total_results)
            tab.attr("data-total-pages", total_pages)
            tab.parent().addClass('loaded')
        if $.inArray(args.post_type, ['forum_side','members_side']) < 0
          window.pending_loading_ta_search_results -= 1
          if window.pending_loading_ta_search_results == 0 and $('#ta-search-page .item-list-tabs .socialv-subtab-container ul li a.active').length == 0
            if $('#ta-search-page .item-list-tabs .socialv-subtab-container ul li a').length > 0
              $('#ta-search-page .item-list-tabs .socialv-subtab-container ul li a').first().trigger('click')
            else
              $('#ta-right-col').addClass('hidden')
              $('#ajax-no-results').removeClass('hidden')
        else
          if $(args.element).find('ul li').length == 0
            $(args.element).parent().append("<div class=\"no-results\">Nessun risultato</div>")
            $(args.element).parent().find('.section-content, > a').remove()
          else
            $(args.element).parent().find('> a').removeClass('hidden')
  else
    console.log 'La ricerca deve contenere almeno 3 caratteri'

$ ->
  # Apertura mini chat
  $('header .better-message-icon a').on 'click', (event)->
    if $('#ta-hidden-messages-box').length > 0
      event.preventDefault()
      $('#ta-hidden-messages-box .bp-messages-mobile-tap').trigger('click')
      window.prev_chat_page = document.location.href
      window.prev_chat_page_title = $('title').first().text()
      url = document.location.origin+'/messages/#/'
      window.history.pushState(null, 'Club dei Presidenti - Messaggi', url)
      document.title = 'Club dei Presidenti - Messaggi'

  $(document).on 'click', '.chat-header', (event)->
    # .mobileClose
    if window.prev_chat_page
      window.history.pushState(null, window.prev_chat_page_title, window.prev_chat_page)
      document.title = window.prev_chat_page_title
      window.prev_chat_page = null
      window.prev_chat_page_title = null

  # Pagina singolo chat con lo shortcode
  if $('.bp-messages-chat-wrap').length > 0
    $('body').addClass('ta-chat-page')
    if $('.full-height-chat').length == 0
      $('.elementor-widget-shortcode').addClass('full-height-chat')
    $('.elementor-widget-shortcode').parents('.e-parent').addClass('content-full-height-chat')
    if $('.bm-editor-content').length > 0
      $('.bm-editor-content').focus()
    else
      window.ta_focus_current_chat_interval = setInterval ->
        if $('.bm-editor-content').length > 0
          $('.bm-editor-content').focus()
          clearInterval window.ta_focus_current_chat_interval
      , 300

  # Pagina con tutte le chat
  if $('.bp-messages-wrap-main').length > 0
    window.current_chat_id = if $('.bpbm-chat-content').length > 0 then parseInt($('.bpbm-chat-content').attr('data-thread-id'), 10) else 0
    if window.current_chat_id != 0
      $('.bm-editor-content').focus()
    else if document.location.hash.match(/#\/conversation\/[0-9]+$/)
      window.ta_focus_current_chat_interval = setInterval ->
        if $('.bm-editor-content').length > 0
          $('.bm-editor-content').focus()
          clearInterval window.ta_focus_current_chat_interval
      , 300
    $(document).on 'click', '.bp-messages-wrap .threads-list .thread', ->
      window.ta_focus_chat = false
      window.ta_focus_chat_interval = setInterval ->
        chat_id = if $('.bpbm-chat-content').length > 0 then parseInt($('.bpbm-chat-content').attr('data-thread-id'), 10) else 0
        console.log 'Apertura chat '+chat_id
        if not window.ta_focus_chat and chat_id != window.current_chat_id
          window.current_chat_id = chat_id
          window.ta_focus_chat = true
          $('.bm-editor-content').focus()
          clearInterval window.ta_focus_chat_interval
      , 300
      setTimeout ->
        clearInterval window.ta_focus_chat_interval
      , 2000

  # stickyFooter()
  check_user_menu()
  fixGridColumns()

  # Autocomplete per chrome
  if $.browser and $.browser.chrome
    $('input[autocomplete="off"]').each ->
      $(@).attr("autocomplete", "chromenonrompere")

  $(document).on "click", ".ta-onoff-checkbox[data-disabled=false]", ->
    el = $(@)
    change_onoff(el)
    real_input = el.prev("input[type=checkbox]")
    checked = real_input.is(":checked")
    if el.hasClass('check-all')
      idx = el.parents('td').index()+1
      el.parents('table').find('tbody tr td:nth-child('+idx+') .ta-onoff-checkbox[data-disabled="false"]').each ->
        el2 = $(@)
        unless el2.hasClass('check-all')
          real_input2 = el2.prev("input[type=checkbox]")
          checked2 = real_input2.is(":checked")
          if checked == checked2
            change_onoff(el2)
    else
      idx = el.parents('td').index()+1
      checkAll = el.parents('table').find('tbody tr td:nth-child('+idx+') .ta-onoff-checkbox.check-all[data-disabled="false"]').first()
      if checkAll.length > 0
        allSize = 0
        checkedSize = 0
        el.parents('table').find('tbody tr td:nth-child('+idx+') .ta-onoff-checkbox[data-disabled="false"]:not(.check-all)').each ->
          allSize += 1
          checkedSize += 1 if $(@).prev("input[type=checkbox]:checked").length > 0
        notCheckedSize = allSize-checkedSize
        real_input_all = checkAll.prev("input[type=checkbox]")
        checked2 = real_input_all.is(":checked")
        if (checked and checked == checked2) or (not checked and checked == checked2 and notCheckedSize == allSize)
          change_onoff(checkAll)

  if document.location.hash != '' and document.location.hash != '#/' and not document.location.hash.match(/\//) and $(document.location.hash).length > 0
    $('html, body').scrollTop $(document.location.hash).offset().top-50

  $('#home-club form > label, #home-club form .field > label').on 'click', ->
    form = $(@).parents('form')
    field = form.find('#'+$(@).attr('for'))
    field.focus()

  $('#home-club form > input, #home-club form .field > input').on 'change', ->
    if($(@).val() != '')
      $(@).prev('label').addClass('active')

  $('#home-club form > input, #home-club form .field > input').on 'focusin', ->
    $(@).prev('label').addClass('active')

  $('#home-club form > input, #home-club form .field > input').on 'focusout', ->
    if($(@).val() == '')
      $(@).prev('label').removeClass('active')

  # Link per copiare un url
  $(".copy-button").addClass('clipboard')
  clipboard = new ClipboardJS '.copy-button', {
    text: (trigger)->
      trigger.getAttribute('data-url')
  }
  clipboard.on 'success', (e)->
    alert e.trigger.getAttribute('data-text')

  # Filtro categorie
  $('#content-select-category select').on 'change', ->
    val = $(@).val()
    $('.course-block').show()
    if val != ''
      if $('#ajax_container .navigation').length > 0
        document.location = "/courses/?sfwd_cat_id=#{val}"
      else
        $('.course-block').each ->
          $(@).hide() if $(@).find(".category[data-id='#{val}']").length == 0
    else if $('#ajax_container .navigation').length > 0
      document.location = "/courses/"
    n_show_courses = $('.course-block:visible').length
    n_columns = if n_show_courses < 3 then n_show_courses else 3
    $('.course-block').first().parent().attr('class', "columns#{n_columns}")

  # Rimuovi sidebar se vuota
  if $('#post-content .entry.with-sidebar').length > 0 and $('#sidebar > div').length == 1 and $('#sidebar > div').html() == ''
    $('#post-content .entry.with-sidebar').removeClass('with-sidebar')
    $('#sidebar').remove()

  # Gestione commenti
  $(".wrap-comments-content textarea").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $(".wrap-comments-content textarea").on "focus", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $('#add-comment-link').on 'click', (event)->
    event.preventDefault()
    $('textarea#comment').focus() unless $('.wrap-comments-content').hasClass('open')

  $("#show-comments").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    textareaComment = $(".wrap-comments-content textarea")
    showComments = $(@)
    next = showComments.attr('data-opposite-text')
    actual = showComments.html()
    titleBtn = showComments.attr("title")
    if actual != titleBtn
      wrapComments.addClass('open')
    else
      wrapComments.removeClass('open')
      if textareaComment.val() == ""
        textareaComment.val textareaComment.attr('data-default')
    showComments.attr 'data-opposite-text', actual
    showComments.html next
  # Fine gestione commenti

  # Click sulla lente di ingrandimento nella barra di ricerca
  $('#header-search-form .form-search label').on 'click', ->
    if $(window).width() < 601
      if $(@).parents('header').hasClass('open-search')
        $(@).parents('form').trigger('submit')
      else
        $(@).parents('header').addClass('open-search')
    else
      $(@).parents('form').trigger('submit')

  # Apertura ricerca su mobile
  $('#navbarSupportedContent').on 'click', (event)->
    if $(window).width() < 601 and not $(@).parents('header').hasClass('open-search') and not $(event.target).hasClass('close-mobile')
      $(@).parents('header').addClass('open-search')
      $(@).find('.search-input').focus()

  # Chiudi box di ricerca mobile
  $('#header-search-form .form-search .close-mobile').on 'click', ->
    $(@).parents('header').removeClass('open-search')

  # Box temi caldi
  if $('#navbarSupportedContent #hot-topics').length == 0
    $.ajax
      url: "/wp-admin/admin-ajax.php?action=hot_topics"
      type: "POST"
      success: (response, status, xhr)->
        $('#navbarSupportedContent').append response
        if $('header #navbarSupportedContent .search-form.hot-topics-opened .form-search.focus').length > 0
          $('#navbarSupportedContent #hot-topics').removeClass('hidden')
          $('#header-search-form').addClass('hot-topics-opened')

  $('#header-search-form .form-search input').on 'focus', ->
    $(@).parents('.form-search').addClass('focus')
    $('#navbarSupportedContent #hot-topics').removeClass('hidden')
    $('#header-search-form').addClass('hot-topics-opened')

  $('#header-search-form .form-search input').on 'focusout', ->
    $(@).parents('.form-search').removeClass('focus')

  $(document).on 'click', '#hot-topics > div', (event)->
    box = $(@)
    # Seleziono l'eventuale link cliccato
    clicked_link = null
    clicked_link = $(event.target) if $(event.target).prop('tagName') == 'A'
    clicked_link = $(event.target).parents('a') if $(event.target).parents('a').length > 0
    console.log clicked_link
    if not clicked_link and box.data().link != '#'
      event.preventDefault()
      if box.data().target == "_blank"
        window.open(box.data().link, "_blank")
      else
        document.location = box.data().link

  $('#navbarSupportedContent .search-form .form-search .close-mobile').on 'click', ->
    $('#navbarSupportedContent #hot-topics').addClass('hidden')
    $('#header-search-form').removeClass('hot-topics-opened')
  # FINE box temi caldi

  # Click sui risultati di ricerca che non hanno la classe ta-topic
  $('.ta-search-result').on 'click', (event)->
    result = $(@)
    if result.data().desc?
      event.preventDefault()
      _target = if result.attr('target')? then result.attr('target') else '_self'
      # Prima di mandare a vedere il risultato mi salvo cosa ha cliccato
      saveClickSearchResult(result.data().desc, result.attr('href'), _target, result)

  window.loadTopicAjax = (ta_topic)->
    if ta_topic.hasClass('ta-blog') or ta_topic.hasClass('ld-course')
      document.location = ta_topic.data().link
    else
      $('#ta-ajax-overlay').removeClass('hidden')
      _link = ta_topic.data().link
      search_key = if ta_topic.hasClass('search') then $('header #navbarSupportedContent .search-form .form-search input').val() else null
      page_id = if $('.page-id').length > 0 and $('.page-id').data().pageId? then $('.page-id').data().pageId else null
      back_link = $('#ta-back-url')
      $.get _link, (data)->
        $('#page-content').html data
        $('#ta-ajax-overlay').addClass('hidden')
        back_url = document.location.href
        back_title = $('title').first().text()
        site_name = $('meta[property="og:site_name"]').attr('content')
        _title = if ta_topic.data().title? then ta_topic.data().title else ta_topic.find('.topic-title').text()
        ta_topic_title = site_name+" - "+_title
        window.history.pushState(null, ta_topic_title, _link)
        document.title = ta_topic_title
        $('title').first().text(ta_topic_title)
        if ta_topic.hasClass('ta-forum')
          $('body').addClass('single-forum')
          $('html, body').scrollTop(0)
          if back_link.length > 0
            back_link.attr('href', '#').addClass('hidden').removeClass('ajax')
            back_link.removeData('page-title')
            back_link.removeData('search-key')
            back_link.removeData('page-id')
        else
          window.init_redactorx("#page-content")
          if back_link.length > 0
            back_link.attr('href', back_url).removeClass('hidden').addClass('ajax')
            back_link.data().pageTitle = back_title
            back_link.data().searchKey = search_key if search_key
            back_link.data().pageId = page_id if page_id
          if ta_topic.data().bodyClasses?
            $('body').addClass(ta_topic.data().bodyClasses)
          else
            $('body').addClass('topic')
          if _link.match(/#[a-zA-Z0-9_-]+$/)
            setTimeout ->
              $('html, body').scrollTop($("#"+_link.split('#')[1]).offset().top-75)
            , 500
          else
            $('html, body').scrollTop(0)
        fix_left_menu_small_position()
        if typeof taSavePageView == 'function'
          window.taSavePageView(ta_topic.data().id, _link)
        if ta_topic.hasClass('search')
          $('header #navbarSupportedContent .search-form .form-search input').val('')

  # Click sul box del topic
  $(document).on 'click', '.ta-topic', (event)->
    ta_topic = $(@)
    # Seleziono l'eventuale link cliccato
    clicked_link = null
    clicked_link = $(event.target) if $(event.target).prop('tagName') == 'A'
    clicked_link = $(event.target).parents('a') if $(event.target).parents('a').length > 0
    # Setto a null il link cliccato se si è cliccato sul link che manda a vedere il risultato di una ricerca
    clicked_link = null if clicked_link and ta_topic.hasClass('search') and clicked_link.hasClass('permalink')
    # Setto a null il link se ha lo stesso href del data-link
    clicked_link = null if clicked_link and clicked_link.attr('href') == ta_topic.data().link
    # Setto a null se si è sulla ricerca nell'app
    clicked_link = null if ta_topic.hasClass('search') and $('body.in-canvas-app').length > 0
    if (clicked_link and $(event.target).parents('.content').length == 0) or $(@).hasClass('full')
      # È stato cliccando un link o è la visualizzazione di un post singolo
      # Click sul forum
      if not $(@).hasClass('full') and clicked_link and clicked_link.hasClass('forum-title')
        event.preventDefault()
        clicked_link.data().link = clicked_link.attr('href')
        clicked_link.data().title = clicked_link.text()
        loadTopicAjax(clicked_link)
    else if $('body.clk-moderator').length > 0 and $(event.target).hasClass('score') and $(event.target).parents('.bbp-voting').length > 0
      # Click sul box per vedere chi ha votato un post
      event.preventDefault()
    else if $(@).hasClass('search')
      # Click sul risultato della ricerca
      # Quindi prima di mandare a vedere il risultato mi salvo cosa ha cliccato
      event.preventDefault()
      _target = if ta_topic.data().target? then ta_topic.data().target else '_self'
      saveClickSearchResult(ta_topic.data().desc, ta_topic.data().link, _target, ta_topic)
    else
      event.preventDefault()
      if ta_topic.data().target == "_blank"
        window.open(ta_topic.data().link, "_blank")
      else
        # document.location = ta_topic.data().link
        loadTopicAjax(ta_topic)

  # Caricamento ajax su click topic dalla pagina dashboard-club
  $(document).on 'click', '.topic-row', (event)->
    event.preventDefault()
    loadTopicAjax($(@))

  # Click sul corso dalla pagina dashboard-club
  $(document).on 'click', '.course-row', (event)->
    event.preventDefault()
    _link = $(@).find('h3 a').attr('href')
    document.location = _link

  # Click sulla freccia per tornare indietro
  $('#ta-back-url').on 'click', (event)->
    back_link = $(@)
    if back_link.hasClass('ajax')
      event.preventDefault()
      $('#ta-ajax-overlay').removeClass('hidden')
      _link = back_link.attr('href')
      if _link != '#'
        is_search_page = if back_link.data().searchKey? then back_link.data().searchKey else false
        page_id = if back_link.data().pageId? then back_link.data().pageId else 0
        $.get _link, (data)->
          back_link.attr('href', '#').addClass('hidden').removeClass('ajax')
          back_link.removeData('page-title')
          back_link.removeData('search-key')
          back_link.removeData('page-id')
          $('#page-content').html data
          $('#ta-ajax-overlay').addClass('hidden')
          window.history.pushState(null, back_link.data().pageTitle, _link)
          document.title = back_link.data().pageTitle
          $('title').first().text(back_link.data().pageTitle)
          fix_left_menu_small_position()
          if typeof taSavePageView == 'function'
            window.taSavePageView(page_id, _link)
          if is_search_page
            $('header #navbarSupportedContent .search-form .form-search input').val(is_search_page)
            first_load_search_results()

  # Click sul box della notifica
  $('header .dropdown-notifications .dropdown-menu .item-body .socialv-notification-box').on 'click', ->
    if ($(event.target).prop('tagName') == 'A' or $(event.target).parents('a').length > 0)
      # non faccio niente
    else
      link = $(@).find('a').first()
      if link.attr('target') == "_blank"
        window.open(link.attr('href'), "_blank")
      else
        document.location = link.attr('href')

  # Visualizzo il box di condivisione
  $(document).on 'click', '.share-link', (event)->
    event.preventDefault()
    share_box = $(@).next()
    if share_box.is(':visible')
      share_box.addClass('hidden')
    else
      share_box.removeClass('hidden')

  # Rispondi
  $(document).on 'click', '.custom-reply', (event)->
    event.preventDefault()
    link = $(@)
    reply_box = link.parents('.replies-tab-table').find('.reply-box')
    if reply_box.is(':visible')
      reply_box.addClass('hidden')
    else
      if reply_box.html() == ''
        parent_id = reply_box.parents('.replies-tab-table').attr('id')
        base_form = $('.card-main form[name="new-post"]')
        new_form = base_form.clone()
        if new_form.find('input[name="bbp_reply_to"]').length > 0
          new_form.find('input[name="bbp_reply_to"]').val(link.data().id)
        else
          new_form.prepend("<input type=\"hidden\" name=\"bbp_reply_to\" id=\"bbp_reply_to\" value=\"#{link.data().id}\">")
        # new_form.find('.socialv-check').remove()
        new_form.find('#bbp_reply_submit').text('Rispondi')
        new_form.find('textarea').val('')
        new_form.find('textarea').attr('id', "bbp_reply_content_#{link.data().id}")
        new_form.find('.rx-container').remove()
        if new_form.find('.edit-user').length > 0
          new_form.find('.edit-user a').data().field = "##{parent_id} #bbp_reply_author"
          new_form.find('.edit-user a').attr('data-field', "##{parent_id} #bbp_reply_author")
          new_form.find('.edit-user a').data().label = "##{parent_id} .edit-user .user-name"
          new_form.find('.edit-user a').attr('data-label', "##{parent_id} .edit-user .user-name")
        reply_box.append(new_form)
        window.init_redactorx("##{parent_id}")
        reply_box.find('.rx-button-topbar[data-name="savebtn"] .rx-button-icon span').text 'Rispondi'
      reply_box.removeClass('hidden')

  # Nuovo topic
  window.checkSubmitTopic = ->
    form = $('.ta-topic-form')
    form.find('.required').trigger('change')

  $('.ta-topic-form #bbp_topic_title').on 'change keyup', ->
    if $(@).val() == ''
      $(@).parents('.form-floating').addClass('error')
    else
      $(@).parents('.form-floating').removeClass('error')

  $('.ta-topic-form textarea[name="bbp_topic_content"]').on 'change', ->
    if $(@).val() == ''
      $(@).parents('.content-tab').addClass('error')
    else
      $(@).parents('.content-tab').removeClass('error')

  $('.ta-topic-form #bbp_topic_tags').on 'change', ->
    tag = $(@).val()
    if tag == ''
      $(@).parents('.form-floating').addClass('error')
    else
      $(@).parents('.form-floating').removeClass('error')

  $('.ta-topic-form #bbp_forum_id').on 'change', ->
    forum_id = $(@).val()
    if forum_id != ''
      $(@).parents('.form-floating').removeClass('error')
      opt = $(@).find("option[value=\"#{forum_id}\"]")
      title = 'Nuovo post in: '+opt.text()
      url = opt.data().url
      icon = opt.data().icon
      excerpt = opt.data().excerpt
      description = opt.data().description
      date = opt.data().date
      subscribers = opt.data().subscribers
      uri = opt.data().uri
      subscription_btn = opt.data().subscription
      if $('#info-post').length > 0
        icon_val = if icon != '' then "url(#{icon})" else 'none'
        $('#info-post .icon').css("background-image", icon_val)
        $('#info-post .text').attr('href', url)
        $('#info-post .text').text("r/#{uri}")
        $('#info-post .desc').text excerpt
        $('#info-post .created-at span').text "Creato il #{date}"
        $('#info-post .subscribers .number').text subscribers
        $('#info-post #subscription-toggle').replaceWith subscription_btn
        $('#info-post').removeClass('hidden')
      else
        icon_style = if icon != '' then "style=\"background-image: url(#{icon});\"" else ''
        $('#ta-right-col').prepend("<div id=\"info-post\"><div class=\"section-title\"><h2>Informazioni</h2></div><div class=\"info\"><a class=\"icon\" #{icon_style} href=\"#{url}\"></a><a class=\"text\" href=\"#{url}\">r/#{uri}</a><div class=\"desc\">#{excerpt}</div><div class=\"created-at ion-wand\"><span>Creato il #{date}</span></div><div class=\"subscribers\"><div class=\"number\">#{subscribers}</div><div class=\"txt\">Iscritti</div></div>#{subscription_btn}</div></div>")
      if $('#desc-forum').length > 0
        if description == ''
          $('#desc-forum .desc').html ''
          $('#desc-forum').addClass('hidden')
        else
          $('#desc-forum .desc').html description
          $('#desc-forum').removeClass('hidden')
      else
        if description != ''
          $('#ta-right-col').prepend("<div id=\"desc-forum\"><div class=\"section-title\"><h2>Descrizione</h2></div><div class=\"info\"><div class=\"desc\">#{description}</div></div></div>")
      if $('#header-search-form .forum-label-content').length > 0
        icon_val = if icon != '' then "url(#{icon})" else 'none'
        $('#header-search-form .forum-label-content .icon').css("background-image", icon_val)
        $('#header-search-form .forum-label-content .text').text("r/#{uri}")
      else
        icon_style = if icon != '' then "style=\"background-image: url(#{icon});\"" else ''
        $("<span class=\"forum-label-content\"><span class=\"forum-label\"><span class=\"icon\" #{icon_style}></span><span class=\"text\">r/#{uri}</span><span class=\"close ion-ios7-close-outline\"></span></span></span>").insertBefore('#header-search-form .form-search label')
    else
      $(@).parents('.form-floating').addClass('error')
      title = 'Nuovo post'
      url = document.location.origin+'/club/new-topic'
      $('#info-post').addClass('hidden')
      $('#header-search-form .forum-label-content').addClass('hidden')
    if(!$(@).parents('form').hasClass('edit-topic-form'))
      window.history.pushState(null, title, url)
      document.title = title

  $('.ta-topic-form #ta_responsabilita').on 'change', ->
    if $(@).is(':checked')
      $(@).parents('.field').removeClass('error')
    else
      $(@).parents('.field').addClass('error')

  $('.ta-topic-form').on 'submit', (event)->
    checkSubmitTopic()
    if $(@).find('.error').length == 0
      $(@).find('#bbp_topic_submit').prop('disabled', true)
    else
      event.preventDefault()
      field = $(@).find('.error').first()
      offTop = field.offset().top - 65
      $('html, body').scrollTop offTop
  # Fine nuovo topic

  # Nuovo forum
  window.checkSubmitForum = ->
    form = $('.ta-forum-form')
    form.find('.required').trigger('change')

  $('.ta-forum-form #bbp_forum_title').on 'change keyup', ->
    if $(@).val() == ''
      $(@).parents('.form-floating').addClass('error')
    else
      $(@).parents('.form-floating').removeClass('error')

  $('.ta-forum-form #bbp_forum_parent_id').on 'change', ->
    forum_id = $(@).val()
    if forum_id != ''
      $(@).parents('.form-floating').removeClass('error')
      opt = $(@).find("option[value=\"#{forum_id}\"]")
      title = 'Nuovo forum in: '+opt.text()
      url = opt.data().url2
      icon = opt.data().icon
      excerpt = opt.data().excerpt
      description = opt.data().description
      date = opt.data().date
      subscribers = opt.data().subscribers
      uri = opt.data().uri
      subscription_btn = opt.data().subscription
      if $('#info-post').length > 0
        icon_val = if icon != '' then "url(#{icon})" else 'none'
        $('#info-post .icon').css("background-image", icon_val)
        $('#info-post .text').attr('href', url)
        $('#info-post .text').text("r/#{uri}")
        $('#info-post .desc').text excerpt
        $('#info-post .created-at span').text "Creato il #{date}"
        $('#info-post .subscribers .number').text subscribers
        $('#info-post #subscription-toggle').replaceWith subscription_btn
        $('#info-post').removeClass('hidden')
      else
        icon_style = if icon != '' then "style=\"background-image: url(#{icon});\"" else ''
        $('#ta-right-col').prepend("<div id=\"info-post\"><div class=\"section-title\"><h2>Informazioni</h2></div><div class=\"info\"><a class=\"icon\" #{icon_style} href=\"#{url}\"></a><a class=\"text\" href=\"#{url}\">r/#{uri}</a><div class=\"desc\">#{excerpt}</div><div class=\"created-at ion-wand\"><span>Creato il #{date}</span></div><div class=\"subscribers\"><div class=\"number\">#{subscribers}</div><div class=\"txt\">Iscritti</div></div>#{subscription_btn}</div></div>")
      if $('#desc-forum').length > 0
        if description == ''
          $('#desc-forum .desc').html ''
          $('#desc-forum').addClass('hidden')
        else
          $('#desc-forum .desc').html description
          $('#desc-forum').removeClass('hidden')
      else
        if description != ''
          $('#ta-right-col').prepend("<div id=\"desc-forum\"><div class=\"section-title\"><h2>Descrizione</h2></div><div class=\"info\"><div class=\"desc\">#{description}</div></div></div>")
      if $('#header-search-form .forum-label-content').length > 0
        icon_val = if icon != '' then "url(#{icon})" else 'none'
        $('#header-search-form .forum-label-content .icon').css("background-image", icon_val)
        $('#header-search-form .forum-label-content .text').text("r/#{uri}")
      else
        icon_style = if icon != '' then "style=\"background-image: url(#{icon});\"" else ''
        $("<span class=\"forum-label-content\"><span class=\"forum-label\"><span class=\"icon\" #{icon_style}></span><span class=\"text\">r/#{uri}</span><span class=\"close ion-ios7-close-outline\"></span></span></span>").insertBefore('#header-search-form .form-search label')
    else
      $(@).parents('.form-floating').addClass('error')
      title = 'Nuovo forum'
      url = document.location.origin+'/club/new-forum'
      $('#info-post').addClass('hidden')
      $('#desc-forum').addClass('hidden')
      $('#header-search-form .forum-label-content').addClass('hidden')
    window.history.pushState(null, title, url)
    document.title = title

  $('.ta-forum-form #ta_responsabilita').on 'change', ->
    if $(@).is(':checked')
      $(@).parents('.field').removeClass('error')
    else
      $(@).parents('.field').addClass('error')

  $('.ta-forum-form').on 'submit', (event)->
    checkSubmitForum()
    if $(@).find('.error').length == 0
      $(@).find('#bbp_forum_submit').prop('disabled', true)
    else
      event.preventDefault()
      field = $(@).find('.error').first()
      offTop = field.offset().top - 65
      $('html, body').scrollTop offTop

  # Rimuovi selezione forum dalla barra di ricerca
  $(document).on 'click', '.forum-label .close', (event)->
    event.preventDefault()
    $(@).parents('.forum-label-content').addClass('hidden')
    $(@).parents('form').find('input[name="forum_id"]').remove()

  # Menu header
  $('header #header-menu-content > .btn').on 'click', (event)->
    event.preventDefault()
    if $(@).hasClass('selected')
      $(@).removeClass('selected')
    else
      $(@).addClass('selected')

  $('header #header-menu-content ul.header-menu > li > a.with-icon').on 'click', (event)->
    event.preventDefault()
    link = $(@)
    if link.hasClass('selected')
      link.removeClass('selected')
    else
      link.parents('.header-menu').find('> li > a.with-icon').removeClass('selected')
      link.addClass('selected')

  $('header #header-menu-content ul.header-menu > li .forum-lists li.with-icon i').on 'click', (event)->
    event.preventDefault()
    box = $(@).parents('li').find('> .list')
    add_selected = (not box.hasClass('selected'))
    $(@).parents('.forum-lists').find('.list.selected').removeClass('selected')
    if add_selected
      box.addClass('selected')
      $(@).parents('li').find('.subforum-lists li.hidden').removeClass('hidden')

  $('header #header-menu-content #filter-header-menu').on 'keyup', (e)->
    val = $(@).val()
    $('header #header-menu-content ul.header-menu li.section li > .list').removeClass('selected')
    if val.length > 2
      $('header #header-menu-content ul.header-menu li.section .text').each ->
        if $(@).text().toLowerCase().indexOf(val.toLowerCase()) >= 0
          $(@).parents('li').first().removeClass('hidden')
        else
          $(@).parents('li').first().addClass('hidden')
      # Faccio vedere anche l'eventuale padre di un risultato
      $('header #header-menu-content ul.header-menu li.section li:not(.hidden)').each ->
        if $(@).parents('.subforum-lists').length > 0
          parent = $(@).parents('.subforum-lists').parents('li').first()
          parent.removeClass('hidden')
          parent.find('> .list').addClass('selected')
      # Nascondo tutta la sezione se è vuota
      $('header #header-menu-content ul.header-menu li.section').each ->
        $(@).removeClass('hidden')
        if $(@).find('li:visible').length == 0
          $(@).addClass('hidden')
    else
      $('header #header-menu-content ul.header-menu li.section').removeClass('hidden')
      $('header #header-menu-content ul.header-menu li.section .forum-lists li').removeClass('hidden')

  $('header .dropdown-notifications .dropdown-toggle').on 'click', ->
    if $(window).width() < 601
      if $(@).hasClass('selected')
        $(@).removeClass('selected')
      else
        $(@).addClass('selected')

  $('.socialv-header-right .main-profile .user-link').on 'click', ->
    if $(window).width() < 601
      box = $(@).parents('.dropdown-toggle')
      if box.hasClass('selected')
        box.removeClass('selected')
      else
        box.addClass('selected')
  # Fine menu header

  # Tabs
  $('.ta-tabs a').on 'click', (event)->
    event.preventDefault()
    $('.ta-tabs a').removeClass('selected')
    link = $(@)
    link.addClass('selected')
    $('.content-tab').addClass('hidden')
    $('.content-tab textarea').prop('disabled', true)
    $(link.attr('href')+' textarea').prop('disabled', false)
    $(link.attr('href')).removeClass('hidden')
    checkSubmitTopic()
    link.parents('form').find('#custom_post_type').val link.data().type

  # Caricamento immagine/video con drag and drop
  $(".ta-drag-and-drop button").on 'click', (e)->
    e.preventDefault()
    $(@).parents('.ta-drag-and-drop').find('input').click()

  $(".ta-drag-and-drop + .preview .ion-trash-b").on 'click', (e)->
    e.preventDefault()
    btn = $(@)
    preview = btn.parents('.preview')
    box_ded = preview.parent().find('.ta-drag-and-drop')
    preview.addClass('hidden')
    box_ded.removeClass('hidden')
    media = preview.find('img')
    media = preview.find('video') if media.length == 0
    media = preview.find('audio') if media.length == 0
    if media.length > 0
      preview.parents('form').find('input[name="attachment_ids[]"][value="'+media.data().id+'"]').remove()
    preview.find('.content').empty()
    taUpdateTextarea(box_ded)

  $(".ta-drag-and-drop input").on 'change', ->
    files = $(@).prop('files')
    obj = $(@).parents('.ta-drag-and-drop')
    taHandleFileUpload(files, obj)
  $(".ta-drag-and-drop").on 'dragenter', (e)->
    e.stopPropagation()
    e.preventDefault()
    $(@).addClass('dragenter')
  $(".ta-drag-and-drop").on 'dragover', (e)->
    e.stopPropagation()
    e.preventDefault()
  $(".ta-drag-and-drop").on 'drop', (e)->
    obj = $(@)
    obj.removeClass('dragenter')
    e.preventDefault()
    files = e.originalEvent.dataTransfer.files
    taHandleFileUpload(files, obj)

  $(document).on 'dragenter', (e)->
    e.stopPropagation()
    e.preventDefault()
  $(document).on 'dragover', (e)->
    e.stopPropagation()
    e.preventDefault()
    $(".ta-drag-and-drop").removeClass('dragenter')
  $(document).on 'drop', (e)->
    e.stopPropagation()
    e.preventDefault()

  taHandleFileUpload = (files,obj)->
    file = files[0] # Carico solo il primo file
    reader = new FileReader()
    reader.onload = (e)->
      if file.type == "video/mp4"
        _html = '<figure class="placeholder" data-img="'+file.name+'"><div class="embed-responsive"><video src="'+URL.createObjectURL(file)+'" width="100%" height="100%" controls preload="metadata">Il tuo browser non supporta la riproduzione di questo video.</video></div><div class="ion-loading-c"></div></figure>'
      else if file.type.match(/^image\//)
        _html = '<picture class="align-center placeholder" data-img="'+file.name+'"><img decoding="async" src="'+e.target.result+'" alt="'+file.name+'" /><span class="ion-loading-c"></span></picture>'
      else if file.type.match(/^audio\//)
        _html = '<figure class="placeholder wp-block-audio" data-img="'+file.name+'"><audio src="'+URL.createObjectURL(file)+'" controls></audio></figure>'
      obj.parent().find('.preview .content').html _html
      obj.parent().find('.preview').addClass('loading-in-progress')
      obj.parent().find('.preview').removeClass('hidden')
      obj.addClass('hidden')
    reader.readAsDataURL(file)
    fd = new FormData()
    fd.append('file', file)
    if obj.data().ref == 'user-cover'
      fd.append('bp_params[object]', 'user')
      fd.append('bp_params[item_id]', obj.data().userId)
      fd.append('_wpnonce', obj.data().nonce)
    else if obj.data().ref == 'avatar'
      if obj.data().userId?
        fd.append('custom_user_id', obj.data().userId)
    taSendFileToServer(fd, status, obj, file.type)

  taSendFileToServer = (formData, status, obj, file_type)->
    _url = if obj.data().url? then obj.data().url else window.redactorx_upload_url
    $.ajax
      url: _url
      type: "POST"
      contentType: false
      processData: false
      dataType: "JSON"
      cache: false
      data: formData
      success: (response, status, xhr)->
        if obj.data().ref == 'user-cover'
          attachment = response.data
          attachment.id = 0
        else
          attachment = response[0]
        if not attachment
          console.log response
        else if attachment.errors?
          console.log attachment.errors
        else
          keep_url = if attachment.url == 'keep' then true else false
          _html = obj.parent().find('.preview .content').html()
          _html2 = $('<div>'+_html+'</div>')
          _placeholder = _html2.find('picture.placeholder[data-img="'+attachment.name+'"]')
          _placeholder = _html2.find('figure.placeholder[data-img="'+attachment.name+'"]') if _placeholder.length == 0
          if _placeholder.length > 0
            _placeholder.removeClass('placeholder rx-block-focus').removeAttr('data-img')
            _placeholder.find('.ion-loading-c').remove()
            _placeholder.removeClass('loading-in-progress')
            if file_type == 'video'
              video = _placeholder.find('video')
              video.attr('data-id', attachment.id)
              video.attr('src', attachment.url) unless keep_url
            else if file_type.match(/^image\//)
              img = _placeholder.find('img')
              img.attr('data-id', attachment.id)
              img.attr('src', attachment.url) unless keep_url
            else if file_type.match(/^audio\//)
              audio = _placeholder.find('audio')
              audio.attr('data-id', attachment.id)
              audio.attr('src', attachment.url) unless keep_url
            obj.parent().find('.preview .content').html _html2.html()
            taUpdateTextarea(obj)
          else
            _html = ''
            if file_type == 'video'
              _html = '<figure><div class="embed-responsive"><video src="'+attachment.url+'" width="100%" height="100%" controls preload="metadata" data-id="'+attachment.id+'">Il tuo browser non supporta la riproduzione di questo video.</video></div></figure>'
            else if file_type.match(/^image\//)
              _html = '<picture class="align-center"><img decoding="async" src="'+attachment.url+'" data-id="'+attachment.id+'" alt="'+attachment.name+'" /></picture>'
            else if file_type.match(/^audio\//)
              _html = '<figure class="wp-block-audio"><audio src="'+attachment.url+'" controls data-id="'+attachment.id+'"></audio></figure>'
            obj.parent().find('.preview .content').html _html
            obj.parent().find('.preview').removeClass('loading-in-progress')
            taUpdateTextarea(obj)
          if obj.data().ref == 'avatar'
            $('#top-user .info .icon').css
              backgroundImage: 'url('+attachment.url+')'
            $('.socialv-header-right .dropdown-toggle img, .socialv-header-right .dropdown-profile .dropdown-toggle img').attr('src', attachment.url)
            $('#remove-avatar').removeClass('hidden')
          if obj.data().ref == 'user-cover'
            $('#top-user .top-img').addClass('with-image').css
              backgroundImage: 'url('+attachment.url+')'
            $('#remove-cover').removeClass('hidden')
          if obj.parents('form').length > 0 and attachment.id > 0
            obj.parents('form').prepend('<input type="hidden" name="attachment_ids[]" value="'+attachment.id+'" />')

  taUpdateTextarea = (obj)->
    textarea = obj.parent().find('textarea')
    if textarea.length > 0
      new_html = obj.parent().find('.preview .content').html()
      textarea.val new_html
      textarea.html new_html
      textarea.trigger('change')

  $('#ta-change-avatar .preview').on 'click', ->
    unless $(@).hasClass('loading-in-progress')
      $(@).parent().find('.ta-drag-and-drop').find('input').click()

  $('#ta-change-cover .preview').on 'click', ->
    unless $(@).hasClass('loading-in-progress')
      $(@).parent().find('.ta-drag-and-drop').find('input').click()
  # FINE caricamento immagine/video con drag and drop

  # Rimozione avatar
  $('#remove-avatar').on 'click', (event)->
    event.preventDefault()
    if confirm('Sei sicuro?')
      $('#total-overlay').removeClass('hidden')
      link = $(@)
      $.ajax
        url: '/wp-admin/admin-ajax.php'
        type: 'POST'
        dataType: "JSON"
        data:
          action: 'ta_remove_avatar'
          custom_user_id: link.data().userId
        complete: ->
          $('#total-overlay').addClass('hidden')
        success: (response, status, xhr)->
          $('#remove-avatar').addClass('hidden')
          link.parents('#ta-change-avatar').find('.preview .content').html ''
          link.parents('#ta-change-avatar').find('.preview').addClass('hidden')
          link.parents('#ta-change-avatar').find('.ta-drag-and-drop').removeClass('hidden')
          if avatar_url = response.avatar_url
            $('#top-user .info .icon').css
              backgroundImage: 'url('+avatar_url+')'
            $('.socialv-header-right .dropdown-toggle img, .socialv-header-right .dropdown-profile .dropdown-toggle img').attr('src', avatar_url)
          else
            console.log response.errors
            alert "Si è verificato un errore durante la cancellazione dell'avatar. Riprova più tardi."

  # Rimozione cover utente
  $('#remove-cover').on 'click', (event)->
    event.preventDefault()
    if confirm('Sei sicuro?')
      $('#total-overlay').removeClass('hidden')
      link = $(@)
      $.ajax
        url: '/wp-admin/admin-ajax.php'
        type: 'POST'
        dataType: "JSON"
        data:
          action: link.data().action
          nonce: link.data().nonce
          object: 'user'
          item_id: link.data().userId
        complete: ->
          $('#total-overlay').addClass('hidden')
        success: (response, status, xhr)->
          $('#remove-cover').addClass('hidden')
          link.parents('#ta-change-cover').find('.preview .content').html ''
          link.parents('#ta-change-cover').find('.preview').addClass('hidden')
          link.parents('#ta-change-cover').find('.ta-drag-and-drop').removeClass('hidden')
          $('#top-user .top-img').removeClass('with-image').css
            backgroundImage: 'none'

  # Redactor
  window.ta_fix_redactor_content = ->
    els = if $.isArray(window.redactor_objects) then window.redactor_objects else [window.redactor_objects]
    $.each els, ->
      html = this.app.editor.getContent()
      # Rimuovo i data
      html = html.replace(/\sdata-[^=]+=\"[^\"]+\"/g, "")
      # Rimuovo lo style inline
      html = html.replace(/\sstyle=\"[^\"]+\"/g, "")
      # Rimuovo i tag "stampati"
      html = html.replace(/&lt;[^&]+&gt;/g, "")
      # <p> vuoto all'inzio
      html = html.replace(/^<p[^>]+><\/p>/,"")
      # <p> vuoto alla fine
      html = html.replace(/<p[^>]+><\/p>$/,"")
      # &nbsp;
      html = html.replace(/&nbsp;/g, ' ')
      # span#remove-me-anchor
      html = html.replace(/<span id="remove-me-anchor"><\/span>/,"")
      # Aggiorno l'html
      window.redactor_changed = false
      this.app.editor.setContent
        html: html
        caret: false

  RedactorX.add 'plugin', 'saveplugin',
    start: ->
      try
        btn_text = if $(@.app.$element.nodes[0]).data().savebtnText? then $(@.app.$element.nodes[0]).data().savebtnText else 'Salva'
      catch
        btn_text = 'Salva'
      @.app.topbar.add 'savebtn',
        title: 'Salva',
        icon: '<span>'+btn_text+'</span>',
        command: 'saveplugin.submit'
    submit: (params, button)->
      el_submit = $(@.app.$element.nodes[0]).parents('form').find('button[name="bbp_reply_submit"]')
      el_submit = $(@.app.$element.nodes[0]).parents('form').find('input[type="submit"]') if el_submit.length == 0
      el_submit.trigger('click')

  # Caricamento immagine/video
  RedactorX.add 'plugin', 'uploadMedia',
    start: ->
      @.app.addbar.add 'uploadMediaBtn',
        title: 'Carica',
        icon: '<span class="rx-popup-item-icon rx-icon-image"></span>',
        command: 'uploadMedia.upload'
    upload: (params, button)->
      el_redactor = @
      custom_media_uploader = wp.media
        title: 'Carica una foto o un video o scegline uno dalla libreria'
        library:
          type: ['image','video']
        button:
          text: 'Inserisci'
        multiple: false
      .on 'select', ->
        attachment = custom_media_uploader.state().get('selection').first().toJSON()
        if attachment.type == 'image'
          el_redactor.app.editor.insertContent
            html: '<picture><img decoding="async" src="'+attachment.url+'" alt="'+attachment.name+'" /></picture>'
        else if attachment.type == 'video'
          el_redactor.app.editor.insertContent
            html: '<figure><div class="embed-responsive"><video src="'+attachment.url+'" width="100%" height="100%" controls preload="metadata">Il tuo browser non supporta la riproduzione di questo video.</video></div></figure>'
        else
          console.log attachment
          alert 'Tipo di file non supportato'
      .open()

  # Caricamento immagine
  RedactorX.add 'plugin', 'taAddImage',
    start: ->
      button =
        title: 'Immagine',
        icon: '<i class="rx-icon-image"></i>'
        command: 'taAddImage.upload'
        blocks:
          all: 'editable'
      this.app.toolbar.add 'taAddImage', button
      this.app.editor.addButton 'taAddImage', button
    upload: (params, button)->
      _params =
        box: true
        placeholder: 'Immagine'
        url: window.redactorx_upload_url
        name: 'file'
        data: false
        multiple: false
        success: 'taAddImage.insertByUpload'
        error: 'image.error'
      _id = "image-upload-"+Date.now()
      item = this.app.dom('<input type="file" id="'+_id+'">')
      this.app.$body.append(item)
      this.app.create 'upload', item, _params
      upload_box = item.prev('.rx-form-upload-box')
      upload_box.data('ref', _id)
      upload_box.addClass('hidden')
      item.click()
    insertByUpload: (response)->
      attachment = response[0]
      _html = this.app.editor.getEditor().html().replace(/(\r\n|\n|\r)/gm, "")
      _html2 = $('<div>'+_html+'</div>')
      img_placeholder = _html2.find('picture.placeholder[data-img="'+attachment.name+'"]')
      if img_placeholder.length > 0
        img_placeholder.removeClass('placeholder rx-block-focus').removeAttr('data-img')
        img_placeholder.find('.ion-loading-c').remove()
        img_placeholder.removeClass('loading-in-progress')
        img_placeholder.find('img').attr('src', attachment.url).attr('data-id', attachment.id)
        if attachment.webp_url?
          img_placeholder.prepend('<source srcset="'+attachment.webp_url+'" type="image/webp" />')
        this.app.editor.setContent
          html: _html2.html()
          caret: false
      else
        _html = '<picture class="align-center">'
        if attachment.webp_url?
          _html += '<source srcset="'+attachment.webp_url+'" type="image/webp" />'
        _html += '<img decoding="async" src="'+attachment.url+'" data-id="'+attachment.id+'" alt="'+attachment.name+'" />'
        _html += '</picture>'
        this.app.editor.insertContent
          html: _html
      if this.app.$element.parents('form').length > 0 and attachment.id > 0
        this.app.$element.parents('form').prepend('<input type="hidden" name="attachment_ids[]" value="'+attachment.id+'" />')
      window.ta_fix_redactor_content()

  # Caricamento video
  RedactorX.add 'plugin', 'taAddVideo',
    start: ->
      button =
        title: 'Video',
        icon: '<i class="ion-play"></i>'
        command: 'taAddVideo.upload'
        blocks:
          all: 'editable'
      this.app.toolbar.add 'taAddVideo', button
      this.app.editor.addButton 'taAddVideo', button
    upload: (params, button)->
      _params =
        box: true
        placeholder: 'Video'
        url: window.redactorx_upload_url
        name: 'file'
        data: false
        multiple: false
        success: 'taAddVideo.insertByUpload'
        error: 'image.error'
      _id = "video-upload-"+Date.now()
      item = this.app.dom('<input type="file" id="'+_id+'">')
      this.app.$body.append(item)
      this.app.create 'upload', item, _params
      item.attr('accept', 'video/mp4')
      upload_box = item.prev('.rx-form-upload-box')
      upload_box.data('ref', _id)
      upload_box.addClass('hidden')
      item.click()
    insertByUpload: (response)->
      attachment = response[0]
      _html = this.app.editor.getEditor().html().replace(/(\r\n|\n|\r)/gm, "")
      _html2 = $('<div>'+_html+'</div>')
      _placeholder = _html2.find('figure.placeholder[data-img="'+attachment.name+'"]')
      if _placeholder.length > 0
        _placeholder.removeClass('placeholder rx-block-focus').removeAttr('data-img')
        _placeholder.find('.ion-loading-c').remove()
        _placeholder.removeClass('loading-in-progress')
        _placeholder.find('video').attr('src', attachment.url).attr('data-id', attachment.id)
        this.app.editor.setContent
          html: _html2.html()
          caret: false
      else
        this.app.editor.insertContent
          html: '<figure><div class="embed-responsive"><video src="'+attachment.url+'" width="100%" height="100%" controls preload="metadata" data-id="'+attachment.id+'">Il tuo browser non supporta la riproduzione di questo video.</video></div></figure>'
      window.ta_fix_redactor_content()

  # Caricamento audio
  RedactorX.add 'plugin', 'taAddAudio',
    start: ->
      button =
        title: 'Audio',
        icon: '<i class="ion-music-note"></i>'
        command: 'taAddAudio.upload'
        blocks:
          all: 'editable'
      this.app.toolbar.add 'taAddAudio', button
      this.app.editor.addButton 'taAddAudio', button
    upload: (params, button)->
      _params =
        box: true
        placeholder: 'Audio'
        url: window.redactorx_upload_url
        name: 'file'
        data: false
        multiple: false
        success: 'taAddAudio.insertByUpload'
        error: 'image.error'
      _id = "audio-upload-"+Date.now()
      item = this.app.dom('<input type="file" id="'+_id+'">')
      this.app.$body.append(item)
      this.app.create 'upload', item, _params
      item.attr('accept', 'audio/mp3, audio/ogg, audio/wav')
      upload_box = item.prev('.rx-form-upload-box')
      upload_box.data('ref', _id)
      upload_box.addClass('hidden')
      item.click()
    insertByUpload: (response)->
      attachment = response[0]
      _html = this.app.editor.getEditor().html().replace(/(\r\n|\n|\r)/gm, "")
      _html2 = $('<div>'+_html+'</div>')
      _placeholder = _html2.find('figure.placeholder[data-img="'+attachment.name+'"]')
      if _placeholder.length > 0
        _placeholder.removeClass('placeholder rx-block-focus').removeAttr('data-img')
        _placeholder.find('.ion-loading-c').remove()
        _placeholder.removeClass('loading-in-progress')
        _placeholder.find('audio').attr('src', attachment.url).attr('data-id', attachment.id)
        this.app.editor.setContent
          html: _html2.html()
          caret: false
      else
        this.app.editor.insertContent
          html: '<figure class="wp-block-audio"><audio src="'+attachment.url+'" controls  data-id="'+attachment.id+'"></audio></figure>'
      window.ta_fix_redactor_content()

  window.init_redactorx = (parent="")->
    $("#{parent} textarea[data-type='redactorx']").each ->
      textarea = $(@)
      plugins = ['underline']
      if textarea.data('plugins')?
        $.each textarea.data('plugins').split(' '), (idx,el)->
          plugins.push el

      args = {
        source: false
        plugins: plugins
        buttons:
          context: ['bold', 'italic', 'deleted', 'link']
          topbar: false
        format: ['p', 'h3', 'ul', 'ol']
        editor:
          add: 'bottom'
          lang: 'it'
          minHeight: '200px'
          sync: true
        toolbar:
          sticky: false
        link:
          target: '_blank'
          nofollow: true
          size: 1000
        subscribe:
          'editor.change': ->
            window.redactor_changed = true
            html = @.app.editor.getContent()
            textarea.val html
            textarea.html html
            textarea.trigger 'change'
          'editor.blur': ->
            if window.redactor_changed == true
              window.ta_fix_redactor_content()
              window.redactor_changed = false
          'upload.before.send': (event)->
            file = event.params.files[0]
            reader = new FileReader()
            editor = this.app.editor
            reader.onload = (e)->
              if file.type == "video/mp4"
                editor.insertContent
                  html: '<figure class="placeholder" data-img="'+file.name+'"><div class="embed-responsive"><video src="'+URL.createObjectURL(file)+'" width="100%" height="100%" controls preload="metadata">Il tuo browser non supporta la riproduzione di questo video.</video></div><div class="ion-loading-c"></div></figure>'
              else if file.type.match(/^image\//)
                editor.insertContent
                  html: '<picture class="align-center placeholder" data-img="'+file.name+'"><img decoding="async" src="'+e.target.result+'" alt="'+file.name+'" /><span class="ion-loading-c"></span></picture>'
              else if file.type.match(/^audio\//)
                editor.insertContent
                  html: '<figure class="placeholder wp-block-audio" data-img="'+file.name+'"><audio src="'+URL.createObjectURL(file)+'" controls></audio></figure>'
            reader.readAsDataURL(file)
          'editor.keyup': (event)->
            # Vedo se devo far apparire il box per selezionare l'utente che si vuole menzionare
            # Skippo se si sta cliccando Cancell, Invio, SHIFT, CTRL, OPT, MAIUSCOLO, ESC, sulle freccie, Command
            if $.inArray(event.params.key, [8,13,16,17,18,20,27,37,38,39,40,91,93]) < 0
              text = this.app.editor.getEditor().text()
              text = text.replace(/ /g, ' ')
              offset = this.app.offset.get()
              _end = offset.end
              _start = _end-30
              _start = 0 if _start < 0
              text = text.substring(_start, _end)
              arr_text = text.split(' ')
              last_word = arr_text[arr_text.length-1]
              if last_word.match(/^@/) and last_word.replace('@','').length >= 3
                $('#remove-me-anchor').replaceWith ->
                  $(@).text()
                _s = last_word.replace('@','')
                html = this.app.editor.getContent()
                html = html.replace last_word, '<span id="remove-me-anchor">@'+_s+'</span>'
                this.app.editor.setContent
                  html: html
                this.app.caret.set($('#remove-me-anchor'), 'end')
                window.ta_current_editor = this.app.editor
                _top = $('#remove-me-anchor').offset().top+20
                _left = $('#remove-me-anchor').offset().left
                ta_search_user_for_mention(_s, _top, _left)
              else
                $('#ta-search-user-for-mention').addClass('hidden')
            else if event.params.key == 8 # Se si cancella un tag rimuovo l'eventuale link .ta-user-mention
              text = this.app.editor.getEditor().text()
              text = text.replace(/ /g, ' ')
              text = text.replace(/\n/g, ' ')
              offset = this.app.offset.get()
              _end = offset.end
              _start = _end-30
              _start = 0 if _start < 0
              text = text.substring(_start, _end)
              arr_text = text.split(' ')
              last_word = arr_text[arr_text.length-1]
              if last_word.match(/^@/)
                _html = this.app.editor.getEditor().html()
                _html2 = $('<div>'+_html+'</div>')
                change_html = false
                _html2.find('.ta-user-mention').each ->
                  if $(@).text() == last_word
                    $(@).replaceWith '<span id="remove-me-anchor">'+$(@).text()+'</span>'
                    change_html = true
                if change_html
                  this.app.editor.setContent
                    html: _html2.html()
                  this.app.caret.set($('#remove-me-anchor'), 'end')
            # Navigazione su menzioni
            else if $.inArray(event.params.key, [13,38,40]) >= 0 and $('#ta-search-user-for-mention').is(':visible')
              if event.params.key == 40 # Freccia giù
                prev_el = $('#ta-search-user-for-mention .user.active')
                if prev_el.length > 0 and prev_el.next().length > 0
                  el = prev_el.next()
                  prev_el.removeClass('active')
                  el.addClass('active')
                else if prev_el.length == 0
                  el = $('#ta-search-user-for-mention .user').first()
                  el.addClass('active')
                this.app.caret.set($('#remove-me-anchor'), 'end')
              else if event.params.key == 38 # Freccia sù
                prev_el = $('#ta-search-user-for-mention .user.active')
                if prev_el.length > 0 and prev_el.prev().length > 0
                  el = prev_el.prev()
                  prev_el.removeClass('active')
                  el.addClass('active')
                else if prev_el.length == 0
                  el = $('#ta-search-user-for-mention .user').last()
                  el.addClass('active')
                this.app.caret.set($('#remove-me-anchor'), 'end')
              else if event.params.key == 13 # Invio
                el = $('#ta-search-user-for-mention .user.active')
                if el.length > 0
                  el.removeClass('active')
                  el.trigger('click')
                  event.stop()
          'editor.keydown': (event)->
            if event.params.key == 13 and $('#ta-search-user-for-mention').is(':visible')
              event.stop()
      }

      if textarea.data().minHeight?
        args['editor']['minHeight'] = textarea.data().minHeight

      if textarea.data().buttons?
        if textarea.data().buttons == 'only-link'
          args['toolbar'] = false
          args['context'] = true
          args['plugins'] = []
          args['buttons']['context'] = ['link']
        else
          args['buttons']['context'] = textarea.data().buttons.split(' ')

      if textarea.data().topbar?
        args['buttons']['topbar'] = textarea.data().topbar.split(' ')

      if textarea.data().addbar?
        arr_addbar = textarea.data().addbar.split(' ')
        args['buttons']['addbar'] = arr_addbar
        if $.inArray('image', arr_addbar) >= 0 and textarea.data().customUploader?
          args['image'] = {upload: window.redactorx_upload_url, multiple: false}

      if textarea.data().editor?
        args['buttons']['editor'] = textarea.data().editor.split(' ')

      if textarea.data().format?
        args['format'] = textarea.data().format.split(' ')

      if textarea.data().placeholder?
        args['placeholder'] = textarea.data().placeholder

      if textarea.data().hideAddbar?
        args['addbar'] = false

      window.redactor_objects.push RedactorX(textarea, args)

      # if bp? and bp.mentions?
      #   textarea.bp_mentions(bp.mentions.users)

  window.redactor_objects = []
  window.init_redactorx()
  # FINE redactor

  # Navigazione tra attività utente
  $('#user-page .item-list-tabs a').on 'click', (event)->
    link = $(@)
    if link.attr('href') == '#'
      event.preventDefault();
      link.parents('ul').find('a').removeClass('active')
      link.addClass('active')
      if link.data().show == 'all'
        $('#content-results .ta-topic').removeClass('hidden')
      else
        $('#content-results .ta-topic').addClass('hidden')
        $('#content-results .ta-topic[data-type="'+link.data().show+'"]').removeClass('hidden')

  # Submit remota di una form
  $('form[data-remote="true"]').on 'submit', (event)->
    event.preventDefault()
    form = $(@)
    $.ajax
      url: form.attr('action')
      type: form.attr('method')
      dataType: "JSON"
      cache: false
      data: form.serialize()
      beforeSend: ->
        submit = form.find('button[type="submit"]')
        submit = form.find('input[type="submit"]') if submit.length == 0
        submit.prop('disabled', true)
        if form.find('.loading-form').length > 0
          form.find('.loading-form').removeClass('hidden')
        else
          form.append('<div class="loading-form"><span class="ion-loading-c"></span></div>')
      success: (response, status, xhr)->
        if form.hasClass('profile-edit')
          user_nicename = form.find('input[name="user_nicename"]')
          if user_nicename.val() != user_nicename.data().prev
            document.location = document.location.href.replace(user_nicename.data().prev, user_nicename.val())
        submit = form.find('button[type="submit"]')
        submit = form.find('input[type="submit"]') if submit.length == 0
        submit.prop('disabled', false)
        form.find('.loading-form').addClass('hidden')

  # Controllo Nome Utente
  $('.profile input[name="user_nicename"]').on 'keyup', ->
    username = $(@).val()
    raw_username = username
    # Remove tags
    _div = document.createElement("div")
    _div.innerHTML = username
    username = _div.innerText
    username = remove_accents(username)
    # Keep only numbers, letters and underscore
    username = username.replace(/[^a-zA-Z0-9_]/g,'')
    # remove whitespace.
    username = username.trim()
    username = username.replace('|\s+|', ' ')
    # lowercase
    username = username.toLowerCase()
    # Sostituisco lo username con quello sistemato
    $(@).val(username)

  window.remove_accents = (string)->
    # Decompositions for Latin-1 Supplement.
    chars = {'ª':'a','º':'o','À':'A','Á':'A','Â':'A','Ã':'A','Ä':'A','Å':'A','Æ':'AE','Ç':'C','È':'E','É':'E','Ê':'E','Ë':'E','Ì':'I','Í':'I','Î':'I','Ï':'I','Ð':'D','Ñ':'N','Ò':'O','Ó':'O','Ô':'O','Õ':'O','Ö':'O','Ù':'U','Ú':'U','Û':'U','Ü':'U','Ý':'Y','Þ':'TH','ß':'s','à':'a','á':'a','â':'a','ã':'a','ä':'a','å':'a','æ':'ae','ç':'c','è':'e','é':'e','ê':'e','ë':'e','ì':'i','í':'i','î':'i','ï':'i','ð':'d','ñ':'n','ò':'o','ó':'o','ô':'o','õ':'o','ö':'o','ø':'o','ù':'u','ú':'u','û':'u','ü':'u','ý':'y','þ':'th','ÿ':'y','Ø':'O'}
    # Decompositions for Latin Extended-A.
    chars2 = {'Ā':'A','ā':'a','Ă':'A','ă':'a','Ą':'A','ą':'a','Ć':'C','ć':'c','Ĉ':'C','ĉ':'c','Ċ':'C','ċ':'c','Č':'C','č':'c','Ď':'D','ď':'d','Đ':'D','đ':'d','Ē':'E','ē':'e','Ĕ':'E','ĕ':'e','Ė':'E','ė':'e','Ę':'E','ę':'e','Ě':'E','ě':'e','Ĝ':'G','ĝ':'g','Ğ':'G','ğ':'g','Ġ':'G','ġ':'g','Ģ':'G','ģ':'g','Ĥ':'H','ĥ':'h','Ħ':'H','ħ':'h','Ĩ':'I','ĩ':'i','Ī':'I','ī':'i','Ĭ':'I','ĭ':'i','Į':'I','į':'i','İ':'I','ı':'i','Ĳ':'IJ','ĳ':'ij','Ĵ':'J','ĵ':'j','Ķ':'K','ķ':'k','ĸ':'k','Ĺ':'L','ĺ':'l','Ļ':'L','ļ':'l','Ľ':'L','ľ':'l','Ŀ':'L','ŀ':'l','Ł':'L','ł':'l','Ń':'N','ń':'n','Ņ':'N','ņ':'n','Ň':'N','ň':'n','ŉ':'n','Ŋ':'N','ŋ':'n','Ō':'O','ō':'o','Ŏ':'O','ŏ':'o','Ő':'O','ő':'o','Œ':'OE','œ':'oe','Ŕ':'R','ŕ':'r','Ŗ':'R','ŗ':'r','Ř':'R','ř':'r','Ś':'S','ś':'s','Ŝ':'S','ŝ':'s','Ş':'S','ş':'s','Š':'S','š':'s','Ţ':'T','ţ':'t','Ť':'T','ť':'t','Ŧ':'T','ŧ':'t','Ũ':'U','ũ':'u','Ū':'U','ū':'u','Ŭ':'U','ŭ':'u','Ů':'U','ů':'u','Ű':'U','ű':'u','Ų':'U','ų':'u','Ŵ':'W','ŵ':'w','Ŷ':'Y','ŷ':'y','Ÿ':'Y','Ź':'Z','ź':'z','Ż':'Z','ż':'z','Ž':'Z','ž':'z','ſ':'s'}
    chars = $.extend({}, chars, chars2)
    # Decompositions for Latin Extended-B.
    chars3 = {'Ə':'E','ǝ':'e','Ș':'S','ș':'s','Ț':'T','ț':'t'}
    chars = $.extend({}, chars, chars3)
    # Euro sign.
    chars4 = {'€':'E'}
    chars = $.extend({}, chars, chars4)
    # GBP (Pound) sign.
    chars5 = {'£':'L'}
    chars = $.extend({}, chars, chars5)
    # Vowels with diacritic (Vietnamese). Unmarked.
    chars6 = {'Ơ':'O','ơ':'o','Ư':'U','ư':'u'}
    chars = $.extend({}, chars, chars6)
    # Grave accent.
    chars7 = {'Ầ':'A','ầ':'a','Ằ':'A','ằ':'a','Ề':'E','ề':'e','Ồ':'O','ồ':'o','Ờ':'O','ờ':'o','Ừ':'U','ừ':'u','Ỳ':'Y','ỳ':'y'}
    chars = $.extend({}, chars, chars7)
    # Hook.
    chars8 = {'Ả':'A','ả':'a','Ẩ':'A','ẩ':'a','Ẳ':'A','ẳ':'a','Ẻ':'E','ẻ':'e','Ể':'E','ể':'e','Ỉ':'I','ỉ':'i','Ỏ':'O','ỏ':'o','Ổ':'O','ổ':'o','Ở':'O','ở':'o','Ủ':'U','ủ':'u','Ử':'U','ử':'u','Ỷ':'Y','ỷ':'y'}
    chars = $.extend({}, chars, chars8)
    # Tilde.
    chars9 = {'Ẫ':'A','ẫ':'a','Ẵ':'A','ẵ':'a','Ẽ':'E','ẽ':'e','Ễ':'E','ễ':'e','Ỗ':'O','ỗ':'o','Ỡ':'O','ỡ':'o','Ữ':'U','ữ':'u','Ỹ':'Y','ỹ':'y'}
    chars = $.extend({}, chars, chars9)
    # Acute accent.
    chars10 = {'Ấ':'A','ấ':'a','Ắ':'A','ắ':'a','Ế':'E','ế':'e','Ố':'O','ố':'o','Ớ':'O','ớ':'o','Ứ':'U','ứ':'u'}
    chars = $.extend({}, chars, chars10)
    # Dot below.
    chars11 = {'Ạ':'A','ạ':'a','Ậ':'A','ậ':'a','Ặ':'A','ặ':'a','Ẹ':'E','ẹ':'e','Ệ':'E','ệ':'e','Ị':'I','ị':'i','Ọ':'O','ọ':'o','Ộ':'O','ộ':'o','Ợ':'O','ợ':'o','Ụ':'U','ụ':'u','Ự':'U','ự':'u','Ỵ':'Y','ỵ':'y'}
    chars = $.extend({}, chars, chars11)
    # Vowels with diacritic (Chinese, Hanyu Pinyin).
    chars12 = {'ɑ':'a'}
    chars = $.extend({}, chars, chars12)
    # Macron.
    chars13 = {'Ǖ':'U','ǖ':'u'}
    chars = $.extend({}, chars, chars13)
    # Acute accent.
    chars14 = {'Ǘ':'U','ǘ':'u'}
    chars = $.extend({}, chars, chars14)
    # Caron.
    chars15 = {'Ǎ':'A','ǎ':'a','Ǐ':'I','ǐ':'i','Ǒ':'O','ǒ':'o','Ǔ':'U','ǔ':'u','Ǚ':'U','ǚ':'u'}
    chars = $.extend({}, chars, chars15)
    # Grave accent.
    chars16 = {'Ǜ':'U','ǜ':'u'}
    chars = $.extend({}, chars, chars16)
    # other characters
    chars17 = {'Ä':'Ae','ä':'ae','Ö':'Oe','ö':'oe','Ü':'Ue','ü':'ue','ß':'ss','Æ': 'Ae','æ': 'ae','Ø': 'Oe','ø': 'oe','Å': 'Aa','å': 'aa','l·l': 'll','Đ': 'DJ','đ': 'dj'}
    chars = $.extend({}, chars, chars17)
    $.each chars, (k,v)->
      string = string.replace(k,v);
    string

  # Bottone per triggerare il click su un altro elemento
  $('button[data-click]').on 'click', (event)->
    event.preventDefault()
    el = $($(@).data().click)
    if el.length > 0
      el.trigger('click')

  # Visualizzazione anteprima immagine appena caricata
  $('input.show-preview[type="file"]').on 'change', (e)->
    field = $(@)
    files = $(@).prop('files')
    file = files[0] # Carico solo il primo file
    reader = new FileReader()
    reader.onload = (e)->
      _html = '<a href="#" data-bs-toggle="modal" data-bs-target="#preview-'+field.attr('name')+'"><img decoding="async" src="'+e.target.result+'" alt="preview" /></a><div class="modal fade" id="preview-'+field.attr('name')+'"><div class="modal-dialog modal-dialog-centered modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-content"><img decoding="async" src="'+e.target.result+'" alt="preview" /></div></div></div></div>'
      field.parent().find('.preview').html _html
      field.parent().find('.preview').removeClass('hidden')
    reader.readAsDataURL(file)

  $(document).on 'keyup', (evt)->
    # Chiusura dialog se si preme il tasto ESC
    if evt.keyCode == 27
      if $('.modal:visible').length > 0
        $('.modal:visible').each ->
          unless $(@).find('#templogin-dialog').is(':visible')
            $(@).find('.btn-close').trigger('click')
      if $('.ta-dialog:visible').length > 0
        $('.ta-dialog:visible').each ->
          $(@).find('.close').trigger('click')

  # Click su bottone sottoscrizione
  bbp_ajax_call = (action, object, type, nonce, update_selector)->
    _data = {
      action : action,
      id     : object,
      type   : type,
      nonce  : nonce
    }

    if typeof bbpEngagementJS == 'undefined'
      bbpEngagementJS = {
        bbp_ajaxurl: add_params_to_url(document.location.href, 'bbp-ajax=true'),
        generic_ajax_error: 'Qualcosa è andato storto. Ricarica la pagina e riprova.'
      }

    $.post bbpEngagementJS.bbp_ajaxurl, _data, (response)->
      if response.success
        $(update_selector).html(response.content)
        $(update_selector).trigger('club:completedAjaxCall')
      else
        if !response.content
          response.content = bbpEngagementJS.generic_ajax_error
        window.alert response.content

  $(document).on 'click', '#info-post span[id="subscription-toggle"] a.subscription-toggle', (e)->
    e.preventDefault()
    _events = jQuery._data($(@)[0], "events")
    if _events == undefined or not _events.click or _events.click[0].selector != 'span a.subscription-toggle'
      $(@).parents('span[id="subscription-toggle"]').data().linkClasses = $(@).attr('class')
      bbp_ajax_call(
        'subscription',
        $(@).data('bbp-object-id'),
        $(@).data('bbp-object-type'),
        $(@).data('bbp-nonce'),
        '#info-post span[id="subscription-toggle"]'
      )

  $(document).on 'club:completedAjaxCall', '#info-post span[id="subscription-toggle"]', ->
    $(@).find('a.subscription-toggle').addClass $(@).data().linkClasses
  # FINE click su bottone sottoscrizione

  # Visualizzazione messaggio di errore se c'è il paramentro failed
  current_params = params_from_url(document.location.href)
  if current_params['failed']?
    title = document.title
    url = remove_params_from_url(document.location.href, ['failed'])
    window.history.pushState(null, title, url)
    document.title = title
    alert 'Si è verificato un errore durante il salvataggio. Riprova più tardi.'

  # Menu mobile
  $('#top-user .info .menu-mobile').on 'click', ->
    if $(@).hasClass('open')
      $(@).removeClass('open')
    else
      $(@).addClass('open')

  # Form cambio password
  $('#change-password-form #account_password').on 'change', ->
    if $(@).val() == ''
      $(@).parent().addClass('error')
    else
      $(@).parent().removeClass('error')

  $('#change-password-form #account_new_password').on 'change', ->
    password_val = $(@).val()
    confirmation_val = $('#change-password-form #account_new_password_confirmation').val()
    if password_val == ''
      $(@).parent().addClass('error')
      $(@).parent().find('.error-message').text 'Questo campo non può essere lasciato vuoto'
    else if confirmation_val != '' and confirmation_val != password_val
      $(@).parent().addClass('error')
      $(@).parent().find('.error-message').text 'Non coincide con la conferma password'
    else
      $(@).parent().removeClass('error')

  $('#change-password-form #account_new_password_confirmation').on 'change', ->
    password_val = $('#change-password-form #account_new_password').val()
    confirmation_val = $(@).val()
    if confirmation_val == ''
      $(@).parent().addClass('error')
      $(@).parent().find('.error-message').text 'Questo campo non può essere lasciato vuoto'
    else if password_val != '' and password_val != confirmation_val
      $(@).parent().addClass('error')
      $(@).parent().find('.error-message').text 'Non coincide con la nuova password'
    else
      $(@).parent().removeClass('error')

  $('#change-password-form').on 'submit', (event)->
    $(@).find('input').trigger('change')
    if $(@).find('.error').length > 0
      event.preventDefault()
  # FINE form cambio password

  # Form password dimenticata
  $('#forgot-password-form #email').on 'change', ->
    if $(@).val() == ''
      $(@).parent().addClass('error')
    else
      $(@).parent().removeClass('error')

  $('#forgot-password-form').on 'submit', (event)->
    $(@).find('input').trigger('change')
    if $(@).find('.error').length > 0
      event.preventDefault()
  # FINE form password dimenticata

  # Click sul numero di commenti sul box di un corso
  $('.course-block .comments-count').on 'click', (event)->
    event.preventDefault()
    document.location = $(@).data().url

  # Dialog con visualizzazioni
  $(document).on 'click', '.view-stats', (event)->
    event.preventDefault()
    link = $(@)
    $.ajax
      url: "/wp-admin/admin-ajax.php?action=ta_pageviews"
      type: "GET"
      dataType: "JSON"
      data:
        post_id: link.data().id
      success: (response, status, xhr)->
        _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
        _html += "<div class=\"top\"><div class=\"title\">Visualizzazioni: "+link.parents('.ta-topic').find('.topic-title').text()+"</div><div class=\"close\"></div></div>"
        _html += "<div class=\"content-ta-dialog\">"
        $.each response, (idx,el)->
          avatar_style = if el.avatar != '' then "style=\"background-image: url('"+el.avatar+"')\"" else ''
          _html += "<div class=\"user\">"
          if el.person_link != '#'
            _html += "<a class=\"avatar\" "+avatar_style+" href=\""+el.person_link+"\" target=\"_blank\"></a>"
          else
            _html += "<span class=\"avatar\" "+avatar_style+"></span>"
          if el.user_link != '#'
            _html += "<a class=\"name\" href=\""+el.user_link+"\" target=\"_blank\">"+el.name+"</a>"
          else
            _html += "<span class=\"name\">"+el.name+"</span>"
          _html += "<span class=\"views\">"+el.views+"</span>"
          _html += "</div>"
        _html += "</div></div></div>"
        $('body').append(_html)

  # Dialog con iscritti
  $('.view-subscribers').on 'click', (event)->
    event.preventDefault()
    link = $(@)
    $.ajax
      url: "/wp-admin/admin-ajax.php?action=ta_subscribers"
      type: "GET"
      dataType: "JSON"
      data:
        post_id: link.data().id
      success: (response, status, xhr)->
        _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
        _html += "<div class=\"top\"><div class=\"title\">Iscrizioni: "+link.data().title+"</div><div class=\"close\"></div></div>"
        _html += "<div class=\"content-ta-dialog\">"
        $.each response, (idx,el)->
          avatar_style = if el.avatar != '' then "style=\"background-image: url('"+el.avatar+"')\"" else ''
          _html += "<div class=\"user\">"
          if el.person_link != '#'
            _html += "<a class=\"avatar\" "+avatar_style+" href=\""+el.person_link+"\" target=\"_blank\"></a>"
          else
            _html += "<span class=\"avatar\" "+avatar_style+"></span>"
          if el.user_link != '#'
            _html += "<a class=\"name big\" href=\""+el.user_link+"\" target=\"_blank\">"+el.name+"</a>"
          else
            _html += "<span class=\"name big\">"+el.name+"</span>"
          _html += "</div>"
        _html += "</div></div></div>"
        $('body').append(_html)

  # Chiusura dialog
  $(document).on 'click', '.ta-dialog .close', ->
    box = $(@).parents('.ta-dialog')
    if box.hasClass('keep')
      box.addClass('hidden')
    else
      box.remove()

  # Seleziona/Deseleziona tutte le notifiche
  $('#select-all-notifications').on 'click', ->
    select_all = $(@)
    $('.notification-check').each ->
      if select_all.is(':checked')
        $(@).prop('checked', true)
      else
        $(@).prop('checked', false)

  # Check su seleziona tutte se cambia la spunta su una singola notifica
  $('.notification-check').on 'click', ->
    select_all = $('#select-all-notifications')
    if $(@).is(':checked')
      tot_check = $('.notification-check').length
      tot_checked = $('.notification-check:checked').length
      if tot_check == tot_checked
        select_all.prop('checked', true)
    else
      select_all.prop('checked', false)

  # Disabilito il bottone salva delle azioni di massa
  $('#notification-bulk-manage').attr('disabled', 'disabled')

  # Riabilito il bottone salva delle azioni di massa quando si seleziona un'azione
  $('#notification-select').on 'change', ->
    $('#notification-bulk-manage').attr('disabled', $(@).val().length <= 0)

  # Salvataggio via ajax delle impostazioni delle notifiche
  $('#table-notifications input[type="checkbox"]').on 'change', ->
    form = $(@).parents('form')
    $.ajax
      url: form.attr('action')
      type: "POST"
      data: form.serialize()
      success: (response, status, xhr)->
        console.log 'OK'
      error: ->
        console.log 'ERROR'

  # Salvataggio in ajax delle iscrizioni sulla pagina del profilo
  $('.box-table-subscriptions .table-subscriptions td.action input[type="checkbox"]').on 'change', ->
    field = $(@)
    row = field.parents('tr')
    table = row.parents('table')
    if row.hasClass('all')
      if field.is(':checked')
        row.removeClass('inactive').addClass('active')
        table.find('tr.inactive:not(.all) td.action .ta-onoff-checkbox').trigger('click')
      else
        row.removeClass('active').addClass('inactive')
        table.find('tr.active:not(.all) td.action .ta-onoff-checkbox').trigger('click')
    else
      bbp_ajax_call(
        'subscription',
        row.data().id,
        '0',
        row.data().nonce,
        '#'+table.attr('id')+' tr:nth-child('+(row.index()+1)+') td.action .hidden'
      )
      all_row = row.parents('table').find('tr.all')
      all_onoff = all_row.find('td.action .ta-onoff-checkbox')
      if field.is(':checked')
        row.removeClass('inactive').addClass('active')
        if table.find('tr.inactive:not(.all)').length == 0 and all_row.hasClass('inactive')
          change_onoff(all_onoff, false)
          all_row.removeClass('inactive').addClass('active')
      else
        row.removeClass('active').addClass('inactive')
        if all_row.hasClass('active')
          change_onoff(all_onoff, false)
          all_row.removeClass('active').addClass('inactive')

  # Iscrizione a singolo topic
  $(document).on 'click', '#topic-subscription', (event)->
    event.preventDefault()
    link = $(@)
    bbp_ajax_call(
      'subscription',
      link.data().id,
      '0',
      link.data().nonce,
      '#topic-subscription .hidden'
    )
    if link.hasClass('ion-ios7-bell')
      link.removeClass('ion-ios7-bell').addClass('ion-ios7-bell-outline')
    else
      link.removeClass('ion-ios7-bell-outline').addClass('ion-ios7-bell')

  # Filtro sulle iscrizioni sulla pagina del profilo
  $('#subscriptions-filter select').on 'change', ->
    _val = $(@).val()
    if _val == 'all'
      $('.box-table-subscriptions .table-subscriptions tbody tr').removeClass('hidden')
    else if _val == 'active'
      $('.box-table-subscriptions .table-subscriptions tbody tr.active').removeClass('hidden')
      $('.box-table-subscriptions .table-subscriptions tbody tr.inactive').addClass('hidden')
    else if _val == 'inactive'
      $('.box-table-subscriptions .table-subscriptions tbody tr.active').addClass('hidden')
      $('.box-table-subscriptions .table-subscriptions tbody tr.inactive').removeClass('hidden')
    $('#list-subscriptions-page .section').each ->
      if $(@).find('.box-table-subscriptions .table-subscriptions tbody tr.hidden').length == $(@).find('.box-table-subscriptions .table-subscriptions tbody tr').length
        $(@).addClass('hidden')
      else
        $(@).removeClass('hidden')

  # Apertura LiveChat da link nel menù
  $('#custom-live-chat-link').on 'click', (event)->
    event.preventDefault()
    if typeof LC_API != 'undefined' and LC_API.is_loaded()
      LC_API.open_mobile_window()
    else
      alert('Servizio momentaneamente non disponibile. Riprova più tardi')
    $(@).parents('#header-menu-content').find('> .btn').removeClass('selected')

  # Cambio society_kind per admin e moderatori
  $('#change-society-kind-form select').on 'change', ->
    $('#total-overlay').removeClass('hidden')
    custom_society_kind = $(@).val()
    $.ajax
      url: '/wp-admin/admin-ajax.php'
      type: 'POST'
      dataType: "JSON"
      data:
        action: 'ta_update_custom_society_kind'
        custom_society_kind: custom_society_kind
      error: ->
        $('#total-overlay').addClass('hidden')
        alert('Si è verificato un errore. Riprova più tardi')
      success: (response, status, xhr)->
        if response.status == 'OK'
          document.location.reload()
        else
          $('#total-overlay').addClass('hidden')
          alert('Si è verificato un errore. Riprova più tardi')

  # Apertura box di login da link nel paywall
  $('.paywall-box p.login a').on 'click', (event)->
    event.preventDefault()
    $('header .btn-login').trigger('click')

  # Ricavo il device usato
  if $('.paywall-box').length > 0
    window.current_device = null
    if typeof WURFL == "undefined"
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = (if 'https:' == document.location.protocol then 'https://' else 'http://') + 'wurfl.io/wurfl.js'
      s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(script, s)
      window.interval_set_device = setInterval ->
        if typeof WURFL != "undefined"
          window.current_device = WURFL.form_factor
          clearInterval window.interval_set_device
      , 1000
    else
      window.current_device = WURFL.form_factor

  # Inserimento email nel paywall
  $('.paywall-box form').on 'submit', (event)->
    event.preventDefault()
    form = $(@)
    email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
    email = form.find('#paywall_email').val()
    email_confirmation = form.find('#paywall_email_confirmation').val()
    society_kind = form.find('select[name="society_kind"]').val()
    privacy = form.find('input[name="privacy"]').is(':checked')
    if(email == '' or not email_rg.test(email) or email_confirmation != '')
      alert('Inserisci un indirizzo email valido')
    else if society_kind == ''
      alert('Seleziona il tipo della tua associazione')
    else if not privacy
      alert('Spunta la casella sul trattamento dei dati')
    else
      $('#total-overlay').removeClass('hidden')
      post_id = if form.parents('.ta-topic').length > 0 then form.parents('.ta-topic').data().id else -1
      if form.parents('#paywall_wapper').length > 0 and post_id == -1
        post_id = form.parents('#paywall_wapper').data().postId
      forum_id = if form.parents('#content-forum').length > 0 then form.parents('#content-forum').data().id else null
      $.ajax
        url: '/wp-admin/admin-ajax.php'
        type: 'POST'
        dataType: "JSON"
        data:
          action: 'ta_paywall_email'
          email: email
          email_confirmation: email_confirmation
          society_kind: society_kind
          post_id: post_id
          forum_id: forum_id
          device: window.current_device
        error: ->
          $('#total-overlay').addClass('hidden')
          alert('Si è verificato un errore. Riprova più tardi')
        success: (response, status, xhr)->
          if response.status == 'OK'
            submitIubendaForm(form)
          else if response.status == 'LIMIT_EXCEEDED'
            $('#total-overlay').addClass('hidden')
            alert("Hai terminato i post gratuiti che puoi vedere quest'anno")
          else
            $('#total-overlay').addClass('hidden')
            alert('Si è verificato un errore. Riprova più tardi')

  # Redirect dopo aver inserito la mail nel paywall
  $('.paywall-box form').on 'ta:iubenda_success', ->
    document.location = '/accesso-al-club/'

  # Click su "Crea post" quando non si hanno i permessi per poterlo fare
  $(document).on 'click', '.new-topic', (event)->
    link = $(@)
    if link.attr('href') == '#'
      event.preventDefault()
      _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
      _html += "<div class=\"top\"><div class=\"title\">Crea post</div><div class=\"close\"></div></div>"
      _html += "<div class=\"content-ta-dialog\">"
      _txt = "La possibilità di scrivere un post è riservata ai soli membri del club.</p><p>Per scoprire di più sul club dei presidenti"
      if $('body').hasClass('sk-asd') or $('body').hasClass('sk-ssd')
        _txt += " di associazioni sportive dilettantistiche"
      else if $('body').hasClass('sk-ets') or $('body').hasClass('sk-npg')
        _txt += " di enti del terzo settore"
      _txt += " <a href=\"#\" class=\"info-club\">clicca qui</a>."
      _html += "<p>"+_txt+"</p>"
      _html += "</div></div></div>"
      $('body').append(_html)

  # Click su "Quesito a TeamArtist" quando non si hanno i permessi per poterlo fare
  $(document).on 'click', '.new-ta-question', (event)->
    link = $(@)
    if link.attr('href') == '#'
      event.preventDefault()
      _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
      _html += "<div class=\"top\"><div class=\"title\">Quesito a TeamArtist</div><div class=\"close\"></div></div>"
      _html += "<div class=\"content-ta-dialog\">"
      _txt = "La possibilità di scrivere un quesito a TeamArtist è riservata ai soli membri del club.</p><p>Per scoprire di più sul club dei presidenti"
      if $('body').hasClass('sk-asd') or $('body').hasClass('sk-ssd')
        _txt += " di associazioni sportive dilettantistiche"
      else if $('body').hasClass('sk-ets') or $('body').hasClass('sk-npg')
        _txt += " di enti del terzo settore"
      _txt += " <a href=\"#\" class=\"info-club\">clicca qui</a>."
      _html += "<p>"+_txt+"</p>"
      _html += "</div></div></div>"
      $('body').append(_html)

  # Click sul bottone per sbloccare un post di un altro tag
  $('#show-other-tag-post').on 'click', (event)->
    $('#total-overlay').removeClass('hidden')
    post_id = $(@).parents('.ta-topic').data().id
    $.ajax
      url: '/wp-admin/admin-ajax.php'
      type: 'POST'
      dataType: "JSON"
      data:
        action: 'ta_update_count_other_tags_current_year'
        post_id: post_id
      error: ->
        $('#total-overlay').addClass('hidden')
        alert('Si è verificato un errore. Riprova più tardi')
      success: (response, status, xhr)->
        if response.status == 'OK'
          document.location.reload()
        else if response.status == 'LIMIT_EXCEEDED'
          alert("Hai terminato i post gratuiti che puoi vedere quest'anno")
          document.location.reload()
        else
          $('#total-overlay').addClass('hidden')
          alert('Si è verificato un errore. Riprova più tardi')

  # Prevent click su bottoni di aiuto
  $('.help-button').on 'click', (event)->
    event.preventDefault()

  first_load_search_results = ->
    if $('#pills-tabContent').length > 0
      # Fix per far visualizzare i risultati della ricerca in base alla tab selezionata
      select_tab = $('#pills-tabContent').data().tab
      select_tab = $('#pills-'+select_tab+'-tab')
      if select_tab.length > 0
        if not select_tab.hasClass('active')
          $('#pills-tab a.active').removeClass('active')
          select_tab.addClass('active')
        if not $('#'+select_tab.attr('aria-controls')).hasClass('active')
          $('#pills-tabContent .tab-pane').removeClass('show active')
          $('#'+select_tab.attr('aria-controls')).addClass('show active')
      else
        select_tab = $('#pills-tab a.active').first()
        $('#'+select_tab.attr('aria-controls')).addClass('show active')

      # Caricamento risultati
      window.pending_loading_ta_search_results = $('#pills-tab a').length
      $('#pills-tab a').each ->
        if $(@).data().type?
          args = {
            post_type: $(@).data().type,
            element: '#'+$(@).attr('aria-controls'),
            current_page: $(@).data().page
            total_pages: $(@).data().totalPages
          }
          ta_search(args)

      # Caricamento risultati forum nel box di lato
      if $('#forum-side .section-content').length > 0
        args = {
          post_type: 'forum_side',
          element: '#forum-side .section-content'
        }
        ta_search(args)

      # Caricamento risultati persone nel box di lato
      if $('#members-side .section-content').length > 0
        args = {
          post_type: 'members_side',
          element: '#members-side .section-content'
        }
        ta_search(args)

  if $('#ta-search-page').length > 0
    first_load_search_results()

    # Cambio tab
    $(document).on 'click', '#pills-tab a', (event)->
      link = $(@)
      if link.attr('id') != 'pills-show-all'
        event.preventDefault()
        if not link.hasClass('active')
          current = $('#pills-tab a.active')
          $('#'+current.attr('aria-controls')).removeClass('show active')
          current.removeClass('active')
          link.addClass('active')
          $('#'+link.attr('aria-controls')).addClass('show active')
          if link.attr('aria-controls') == 'pills-topic'
            $('#ta-right-col').removeClass('hidden')
          else
            $('#ta-right-col').addClass('hidden')
          title = document.title
          url = document.location.origin+link.attr('href')
          window.history.pushState(null, title, url)
          document.title = title
          if typeof taSavePageView == 'function'
            taSavePageView(0, url)

    # Click su "Vedi tutti i forum"
    $(document).on 'click', '#show-all-forum', (event)->
      event.preventDefault()
      $('#pills-forum-tab').trigger('click')
      $('html, body').scrollTop(0)

    # Click su "Vedi tutte le person"
    $(document).on 'click', '#show-all-members', (event)->
      event.preventDefault()
      $('#pills-members-tab').trigger('click')
      $('html, body').scrollTop(0)

    # Paginazione ajax
    $(document).on 'click', '.ta-pagination a', (event)->
      event.preventDefault()
      $('#total-overlay').removeClass('hidden')
      link = $(@)
      _element = link.parents('.tab-pane').attr('id')
      _tab = $('#pills-tab a[aria-controls="'+_element+'"]')
      if link.hasClass('prev')
        _page = _tab.data().page-1
      else if link.hasClass('next')
        _page = _tab.data().page+1
      else
        _page = parseInt(link.text(), 10)
      args = {
        post_type: _tab.data().type,
        element: '#'+_element,
        current_page: _page,
        total_pages: _tab.data().totalPages,
        remove_overlay: true
      }
      ta_search(args)
      _tab.data().page = _page
      $('html, body').scrollTop $('#'+_element).offset().top-65
      title = document.title
      url = link.attr('href')
      window.history.pushState(null, title, url)
      document.title = title
      if typeof taSavePageView == 'function'
        taSavePageView(0, url)

    # Salvataggio ricerca nella statistiche
    if not params_get._kt?
      search_term = $('header #navbarSupportedContent .search-form .form-search input').val()
      if search_term.length > 2
        $.ajax
          url: '/wp-admin/admin-ajax.php'
          type: 'POST'
          dataType: "JSON"
          data:
            action: 'ta_user_search'
            term: search_term
            timestamp: $('#content-forum').data().kt
          success: (response, status, xhr)->
            console.log 'Ricerca salvata'
            title = document.title
            url = add_params_to_url(document.location.href, '_kt='+$('#content-forum').data().kt)
            window.history.pushState(null, title, url)
            document.title = title

  # Aperura sottomenu sul menù dei corsi
  $('#menu-courses a[href="#"]').on 'click', (event)->
    event.preventDefault()
    parent = $(@).parent()
    if parent.hasClass('active')
      parent.removeClass('active')
    else
      parent.addClass('active')

  # Caricamento ajax pagine sul menù dei corsi
  if $('.home-content').length > 0
    window.list_pages = []

    ta_load_home_content = (url, kind, load_nav=true, load_next=true)->
      $.get url, (data)->
        $('#menu-courses').after(data)
        box = $('.home-content[data-kind="'+kind+'"]')
        if kind.match(/^explore-courses-/)
          cat_id = parseInt(kind.replace('explore-courses-',''), 10)
          box.find('.course-block .img .category').addClass('hidden')
          box.find('.course-block .img .category[data-id="'+cat_id+'"]').removeClass('hidden')
        if box.find('.navigation').length > 0
          $('#back-to-top').addClass('with-pagination')
        fixGridColumns()
        if load_nav
          page = 1
          home_content = $('.home-content[data-kind="'+kind+'"][data-page="'+page+'"]')
          ta_load_home_content_pagination(home_content)
        else if load_next and list_pages.length > 0
          a = list_pages.shift()
          b = a.split('|')
          url = b[0]
          kind = b[1]
          ta_load_home_content(url, kind)

    ta_load_home_content_pagination = (home_content)->
      nav = home_content.find('.navigation')
      if nav.length > 0
        kind = home_content.data().kind
        base_url = if kind.match(/^explore-courses-*/) then 'courses' else kind
        current_page = parseInt(nav.find('a.link-curr').text(), 10)
        i = 1
        while i <= nav.data().totalPages
          if current_page != i
            nav_url = "/"+base_url+"/page/"+i+"/"
            if kind.match(/^explore-courses-*/)
              sfwd_cat_id = kind.match(/^explore-courses-([0-9]+)/)[1]
              nav_url += "?sfwd_cat_id="+sfwd_cat_id
            ta_load_home_content(nav_url, kind, false, false)
          i++
      if list_pages.length > 0
        a = list_pages.shift()
        b = a.split('|')
        url = b[0]
        kind = b[1]
        ta_load_home_content(url, kind)

    # Elenco delle pagine da caricare
    $('#menu-courses a[href!="#"]').each ->
      li = $(@).parent()
      unless li.hasClass('selected')
        kind = li.data().kind
        list_pages.push $(@).attr('href')+"|"+kind

    # Mostro il box della pagina corrente
    if $('#menu-courses li.selected').length > 0
      kind = $('#menu-courses li.selected[data-kind]').data().kind
      page = $('#menu-courses li.selected').data().page
      current_box = $('.home-content[data-kind="'+kind+'"][data-page="'+page+'"]')
      if kind.match(/^explore-courses-/)
        cat_id = parseInt(kind.replace('explore-courses-',''), 10)
        current_box.find('.course-block .img .category').addClass('hidden')
        current_box.find('.course-block .img .category[data-id="'+cat_id+'"]').removeClass('hidden')
    else
      current_box = $('.home-content').first()
    current_box.removeClass('hidden')
    setTimeout ->
      ta_load_home_content_pagination(current_box)
      # current_box.trigger('ta:loadContent')
    , 100

    # Carico le pagine
    # $('#menu-courses a[href!="#"]').each ->
    #   li = $(@).parent()
    #   unless li.hasClass('selected')
    #     $.get $(@).attr('href'), (data)->
    #       $('#menu-courses').after(data)
    #       fixGridColumns()
    #       kind = li.data().kind
    #       page = 1
    #       $('.home-content[data-kind="'+kind+'"][data-page="'+page+'"]').trigger('ta:loadContent')

    # Carico le eventuali altre pagine di ogni blocco
    # $(document).on 'ta:loadContent', '.home-content', ->
    #   kind = $(@).data().kind
    #   nav = $(@).find('.navigation')
    #   if nav.length > 0
    #     base_url = if kind.match(/^explore-courses-*/) then 'courses' else kind
    #     current_page = parseInt(nav.find('a.link-curr').text(), 10)
    #     i = 1
    #     while i <= nav.data().totalPages
    #       if current_page != i
    #         url = "/"+base_url+"/page/"+i
    #         if kind.match(/^explore-courses-*/)
    #           sfwd_cat_id = kind.match(/^explore-courses-([0-9]+)/)[1]
    #           url += "?sfwd_cat_id="+sfwd_cat_id
    #         $.get url, (data)->
    #           $('#menu-courses').after(data)
    #           fixGridColumns()
    #       i++

    # Click sulla paginazione
    $(document).on 'click', '.home-content .navigation a', (event)->
      event.preventDefault()
      link = $(@)
      unless link.hasClass('link-curr')
        $('.home-content').addClass('hidden')
        parent = link.parents('.home-content')
        kind = parent.data().kind
        if link.attr('id') == 'articles_prev_link'
          current_page = parseInt(link.parents('.navigation').find('.link-curr').text(), 10)
          page = current_page-1
        else if link.attr('id') == 'articles_next_link'
          current_page = parseInt(link.parents('.navigation').find('.link-curr').text(), 10)
          page = current_page+1
        else
          page = link.text().trim()
        home_content = $('.home-content[data-kind="'+kind+'"][data-page="'+page+'"]')
        home_content.removeClass('hidden')
        url = link.attr('href')
        if url.match(/^\//)
          url = document.location.origin+url
        li = $('#menu-courses li.selected').last()
        li.data().page = page
        $('html, body').scrollTop home_content.offset().top-48
        title = li.data().pageTitle
        if page > 1
          title += " - Pagina "+page
        window.history.pushState(null, title, url)
        document.title = title
        if typeof taSavePageView == 'function'
          taSavePageView(0, url)

    # Al click sul menù mostro la pagina giusta
    $('#menu-courses a[href!="#"]').on 'click', (event)->
      event.preventDefault()
      $('.home-content').addClass('hidden')
      $('#menu-courses li.selected').removeClass('selected')
      link = $(@)
      li = link.parent()
      li.addClass('selected')
      if li.parents('.submenu-menu-courses').length > 0
        li.parents('li').addClass('selected').removeClass('active')
      kind = li.data().kind
      page = if li.data().page? then li.data().page else 1
      $('.home-content[data-kind="'+kind+'"][data-page="'+page+'"]').removeClass('hidden')
      title = li.data().pageTitle
      url = link.attr('href')
      if url.match(/^\//)
        url = document.location.origin+url
      if page > 1
        splitted_url = url.split('?')
        url = splitted_url[0]+"page/"+page+"/"
        if splitted_url.length == 2
          url += "?"+splitted_url[1]
      window.history.pushState(null, title, url)
      document.title = title
      if typeof taSavePageView == 'function'
        taSavePageView(0, url)

  # Disabilitati i voti per i livelli che non possono votare
  if $('body.disabled_votes').length > 0
    $('.bbp-voting').addClass('view-only')
    $('.bbp-voting .vote').on 'click', (event)->
      event.preventDefault()
      _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
      _html += "<div class=\"top\"><div class=\"title\">Operazione non permessa</div><div class=\"close\"></div></div>"
      _html += "<div class=\"content-ta-dialog\">"
      _kind = if $(@).parents('.ta-topic').length > 0 then 'post' else 'commento'
      _html += "<p>Per poter mettere mi piace al "+_kind+" devi essere un membro del Club dei Presidenti. <a href=\"#\" class=\"red info-club\">Clicca qui</a> per avere più informazioni su come diventare un membro del Club dei Presidenti.</p>"
      _html += "</div></div></div>"
      $('body').append(_html)

  # Callback dopo che è stato messo un voto per salvare il dato nelle statistiche
  $('.bbp-voting').on 'bbp_voting', (event,data)->
    if $(@).parents('.replies-tab-table').length > 0
      action_name = 'comment_vote'
      post_id = $(@).parents('.replies-tab-table').attr('id').replace('post-','')
    else
      action_name = 'post_vote'
      post_id = $(@).parents('.ta-topic').data().id
    $.ajax
      url: '/wp-admin/admin-ajax.php'
      type: 'POST'
      dataType: "JSON"
      data:
        action: 'custom_ta_user_activity'
        action_name: action_name
        action_kind: 'hash'
        action_value: data.direction
        action_key: post_id
        parse_int: true
      success: (response, status, xhr)->
        console.log 'Voto salvato'

  # Box con la lista di chi ha votato per i moderatori
  if $('body.clk-moderator').length > 0
    $('.bbp-voting .score').on 'click', ->
      link = $(@)
      post_id = if link.parents('.replies-tab-table').length > 0 then link.parents('.replies-tab-table').attr('id').replace('post-','') else link.parents('.ta-topic').data().id
      $.ajax
        url: '/wp-admin/admin-ajax.php'
        type: 'GET'
        dataType: "JSON"
        data:
          action: 'ta_bbp_voting_list'
          post_id: post_id
        success: (response, status, xhr)->
          _title = if link.parents('.ta-topic').length > 0 then 'Votazioni post: '+link.parents('.ta-topic').find('.topic-title').text() else 'Votazioni commento'
          _html = "<div class=\"ta-dialog\"><div class=\"wrapper-ta-dialog\">"
          _html += "<div class=\"top\"><div class=\"title\">"+_title+"</div><div class=\"close\"></div></div>"
          _html += "<div class=\"content-ta-dialog\">"
          if response.length == 0
            _html += "<p>Nessun utente trovato</p>"
          else
            $.each response, (idx,el)->
              avatar_style = if el.avatar != '' then "style=\"background-image: url('"+el.avatar+"')\"" else ''
              _html += "<div class=\"user\">"
              if el.person_link != '#'
                _html += "<a class=\"avatar\" "+avatar_style+" href=\""+el.person_link+"\" target=\"_blank\"></a>"
              else
                _html += "<span class=\"avatar\" "+avatar_style+"></span>"
              if el.user_link != '#'
                _html += "<a class=\"name small\" href=\""+el.user_link+"\" target=\"_blank\">"+el.name+"</a>"
              else
                _html += "<span class=\"name small\">"+el.name+"</span>"
              _html += "<span class=\"vote\">"+el.vote+"</span>"
              _html += "</div>"
          _html += "</div></div></div>"
          $('body').append(_html)

  # Click sui link per avere maggiori informazioni sul Club dei Presidenti
  $('.info-club').on 'click', (event)->
    event.preventDefault()
    link = $(@)
    # Aggiungo al funnel
    $.ajax
      url: '/wp-admin/admin-ajax.php'
      type: 'POST'
      dataType: "JSON"
      data:
        action: 'ta_add_to_funnel'
        funnel_id: '665db9626b543226ca8de61c'
      complete: ->
        _date = new Date
        _now = _date.getTime()/1000
        # Mi salvo il click nelle statistiche
        $.ajax
          url: '/wp-admin/admin-ajax.php'
          type: 'POST'
          dataType: "JSON"
          data:
            action: 'custom_ta_user_activity'
            action_name: 'club_info'
            action_kind: 'list'
            action_value: _now
          success: (response, status, xhr)->
            # Mando alla pagina messa come href del link
            document.location = '/ammissione-al-club/'

  # Modifica utente in topic e reply
  $(document).on 'click', '.edit-user a', (event)->
    event.preventDefault()
    if $(@).data().field?
      $('#edit-user-dialog').data().field = $(@).data().field
      $('#edit-user-dialog').attr('data-field', $(@).data().field)
    if $(@).data().label?
      $('#edit-user-dialog').data().label = $(@).data().label
      $('#edit-user-dialog').attr('data-label', $(@).data().label)
    $('#edit-user-dialog').removeClass('hidden')

  $('#edit-user-dialog form.search').on 'submit', (event)->
    event.preventDefault()
    form = $(@)
    name = form.find('input[name="name"]').val().trim()
    email = form.find('input[name="email"]').val().trim()
    mobile_phone = form.find('input[name="mobile_phone"]').val().trim()
    if email.length == 0 and mobile_phone.length == 0 and name.length == 0
      alert 'Inserisci dei criteri di ricerca!'
    else if email.length == 0 and mobile_phone.length == 0 and name.length < 3
      alert 'Inserisci almeno 3 caratteri sulla ricerca per nome!'
    else
      $('#edit-user-dialog .search-results').html '<div class="box-loading"><span class="ion-loading-c"></span></div>'
      $.ajax
        url: '/wp-admin/admin-ajax.php'
        type: 'POST'
        dataType: "JSON"
        data:
          action: 'ta_search_user'
          name: name
          email: email
          mobile_phone: mobile_phone
          with_avatar: true
        success: (response, status, xhr)->
          $('#edit-user-dialog .search-results').empty()
          if response.length > 0
            $.each response, (idx,el)->
              user_box = "<div class=\"user\"><span class=\"checkbox-box\"><input type=\"checkbox\" name=\"user_id\" value=\""+el.ID+"\" data-label=\""+el.display_name+"\" /></span><a class=\"avatar\" style=\"background-image: url("+el.avatar_url+")\" href=\""+el.user_link+"\" target=\"_blank\"></a><a class=\"name darken\" href=\""+el.user_link+"\" target=\"_blank\">"+el.display_name+"<br>"+el.user_email+"<br>"+el.mobile_phone+"</a></div>"
              $('#edit-user-dialog .search-results').append user_box
          else
            $('#edit-user-dialog .search-results').append '<h3 class="no-results">Nessun risultato trovato</h3>'
          # Scrollo ai risultati della ricerca
          $('#edit-user-dialog .content-ta-dialog').animate({
            scrollTop: $("#edit-user-dialog .search-results").position().top-110
          }, 400);

  $(document).on 'click', '#edit-user-dialog .checkbox-box input[type="checkbox"]', ->
    el = $(@)
    if el.is(":checked")
      $("#edit-user-dialog .user.selected .checkbox-box input[name='#{el.attr("name")}']").each ->
        $(@).prop("checked", false)
        $(@).parents('.user').removeClass('selected')
      el.parents('.user').addClass('selected')
    else
      el.parents('.user').removeClass('selected')

  $('#change-user').on 'click', (event)->
    event.preventDefault()
    field = $('#edit-user-dialog .checkbox-box input[type="checkbox"]:checked')
    if field.length == 0
      alert 'Seleziona un utente!'
    else
      user_id = field.val()
      user_name = field.data().label
      $($('#edit-user-dialog').data().field).val user_id
      $($('#edit-user-dialog').data().label).text user_name
      $('#edit-user-dialog form.search')[0].reset()
      $('#edit-user-dialog .user:not(.selected)').remove()
      $('#edit-user-dialog .close').trigger('click')

  $('#top-user .info .menu li a[href="#"]').on 'click', (event)->
    event.preventDefault()
    link = $(@)
    if link.hasClass('active')
      console.log 'CHIUDO'
      link.removeClass('active')
    else
      console.log 'APRO'
      link.addClass('active')

  # Eventi PRO
  if $('#list-pro-events').length > 0
    if $("#list-pro-events tr:not('.hidden')").length == 0 && $('#no-results').hasClass('hidden')
      $('#no-results').removeClass('hidden')

    window.events_params = {}
    window.events_params.cat = params_get.cat if params_get.cat?
    window.events_params.tag = params_get.tag if params_get.tag?
    window.events_params.status = if params_get.status? then params_get.status else 'future'
    showEvents = ->
      title = document.title
      url = document.location.origin+document.location.pathname
      $('#list-pro-events tr').removeClass('hidden')
      if window.events_params.cat and window.events_params.cat != ''
        $("#list-pro-events tr[data-cat!='#{window.events_params.cat}']").addClass('hidden')
        url = add_params_to_url(url, 'cat='+window.events_params.cat)
      if window.events_params.tag and window.events_params.tag != ''
        $("#list-pro-events tr[data-tag!='"+window.events_params.tag+"']").addClass('hidden')
        url = add_params_to_url(url, 'tag='+window.events_params.tag)
      if window.events_params.status != 'all'
        $("#list-pro-events tr[data-status!='"+window.events_params.status+"']").addClass('hidden')
      url = add_params_to_url(url, 'status='+window.events_params.status)
      if $('#list-pro-events tr:not(.hidden)').length == 0
        $('#no-results').removeClass('hidden')
      else
        $('#no-results').addClass('hidden')
      window.history.pushState(null, title, url)
      document.title = title

    $('#content-list-pro-events div.item-list-tabs a').on 'click', (event)->
      event.preventDefault()
      window.events_params.status = $(@).data().status
      showEvents()
      $('#content-list-pro-events div.item-list-tabs a').removeClass('active')
      $(@).addClass('active')

    $('#content-list-pro-events .content-selects #cat').on 'change', ->
      window.events_params.cat = $(@).val()
      showEvents()

    $('#content-list-pro-events .content-selects #tag').on 'change', ->
      window.events_params.tag = $(@).val()
      showEvents()

  $('.dropdown-profile-ta .dropdown-toggle').on 'click', ->
    if $(@).next().hasClass('show')
      $(@).next().removeClass('show')
    else
      $(@).next().addClass('show')

  # Menù a sinistra
  $('#left-menu-link').on 'click', (event)->
    event.preventDefault()
    lm = $(@).next('.left-menu')
    if lm.hasClass('show')
      lm.css
        left: "-240px"
      setTimeout ->
        lm.removeClass('show')
        lm.css
          left: ""
      , 400
    else
      lm.addClass('show')

  $('#left-menu-link2').on 'click', (event)->
    event.preventDefault()
    lm = $(@).parents('.left-menu')
    if lm.hasClass('show')
      lm.css
        left: "-240px"
      setTimeout ->
        lm.removeClass('show')
        lm.css
          left: ""
      , 400
    else
      lm.addClass('show')

  $(document).on 'click', '#header-left-menu-content .ion-ios7-arrow-right', (event)->
    event.preventDefault()
    event.stopPropagation()
    $('#header-left-menu-content .left-menu li ul').removeClass('show')
    $(@).parents('a').next().addClass('show')
    $(@).addClass('ion-ios7-arrow-down').removeClass('ion-ios7-arrow-right')

  $(document).on 'click', '#header-left-menu-content .ion-ios7-arrow-down', (event)->
    event.preventDefault()
    event.stopPropagation()
    $('#header-left-menu-content .left-menu li ul').removeClass('show')
    $(@).addClass('ion-ios7-arrow-right').removeClass('ion-ios7-arrow-down')

  $('#header-left-menu-content .left-menu > li > a[href="#"]').on 'click', (event)->
    event.preventDefault()
    $('#header-left-menu-content .left-menu li ul').removeClass('show')
    $(@).next('ul').addClass('show')

  $('header #header-left-menu-content #filter-header-menu').on 'keyup', (e)->
    val = $(@).val()
    $('header #header-left-menu-content li.forum').removeClass('selected')
    if val.length > 2
      $('header #header-left-menu-content li.forum .text').each ->
        if $(@).text().toLowerCase().indexOf(val.toLowerCase()) >= 0
          $(@).parents('li').first().removeClass('hidden')
        else
          $(@).parents('li').first().addClass('hidden')
      # Faccio vedere anche l'eventuale padre di un risultato
      $('header #header-left-menu-content li.forum:not(.hidden)').each ->
        if $(@).parents('.submenu').length > 0
          parent = $(@).parents('.submenu').parents('li').first()
          parent.removeClass('hidden')
          $(@).parents('.submenu').addClass('show')
    else
      $('header #header-left-menu-content li.forum').removeClass('hidden')
      $('header #header-left-menu-content li.forum .submenu').removeClass('show')

  fix_left_menu_small_position = ->
    scroll_top = $(document).scrollTop()
    _start = 0
    if $('body.single-forum').length > 0 or $('body.topic').length > 0 or ($('body.courses-page').length > 0 and $('.bp-messages-chat-wrap').length == 0)
      _limit = 55
      if $('body.courses-page').length > 0
        if $('.ta-head-webinar').length > 0 or $('.elementor').length > 0
          _start = 49
        else
          _start = 107
        _limit = 49
      else if $('.elementor').length > 0
        _start = 49
        _limit = 49
      else
        _start = if $('#top-forum .top-img.with-image').length > 0 then 299 else 135
        if _start == 299
          $('#left-menu-small').addClass('under')
    else if $('.elementor').length > 0
      _start = 49
      _limit = 49
    if _start > 0
      new_top = _start - scroll_top
      new_top = _limit if new_top < _limit
      new_height = $(window).height()-new_top
      $('#left-menu-small').css
        top: new_top
        visibility: 'visible'
      $('#left-menu-small ul').css
        height: new_height

  fix_left_menu_small_position()

  $(document).on 'scroll', ->
    fix_left_menu_small_position()
  # FINE Menù a sinistra

  # Fix per segnare come letta la notifica dei messaggi
  if $.inArray('bp-messages', document.location.pathname.split('/')) >= 0
    if document.location.hash.match(/\?/)
      str_params = document.location.hash.split('?')[1]
      _params = params_from_url('?'+str_params)
      if $.inArray('n_action', Object.keys(_params)) >= 0
        $.ajax
          url: "/wp-admin/admin-ajax.php?action=ta_mark_notification_as_read"
          type: "POST"
          dataType: "JSON"
          data:
            _params
          complete: ->
            url = document.location.href.split('?')[0]
            new_str_params = remove_params_from_url('?'+str_params, ['n_action','n_action_type','n_item_id'])
            if new_str_params != ''
              url += '?'+new_str_params
            document.location = url

  window.ta_search_user_for_mention = (s, box_top, box_left)->
    $.ajax
      url: "/wp-admin/admin-ajax.php?action=ta_search_user_for_mention"
      type: "POST"
      dataType: "JSON"
      data:
        s: s
      success: (response, status, xhr)->
        $('#ta-search-user-for-mention').empty()
        if response.length == 0
          $('#ta-search-user-for-mention').addClass('hidden')
        else
          if $('#ta-search-user-for-mention').length == 0
            $('body').append '<div id="ta-search-user-for-mention"></div>'
          $('#ta-search-user-for-mention').css
            top: box_top
            left: box_left
          $.each response, (idx,el)->
            $('#ta-search-user-for-mention').append '<div class="user" data-val="'+el.user_nicename+'" data-id="'+el.ID+'" data-link="'+el.user_link+'">'+el.real_display_name+'</div>'
          $('#ta-search-user-for-mention').data().search = '@'+s
          $('#ta-search-user-for-mention').attr('data-search', '@'+s)
          $('#ta-search-user-for-mention').removeClass('hidden')

  $(document).on 'click', '#ta-search-user-for-mention .user', ->
    $('#remove-me-anchor').replaceWith ->
     $(@).text()
    el = '<a class="ta-user-mention ta-user-id-'+$(@).data().id+'" href="'+$(@).data().link+'" title="'+$(@).text()+'" data-nicename="'+$(@).data().val+'">@'+$(@).text()+'</a>'
    current_editor = window.ta_current_editor
    html = current_editor.getContent()
    html = html.replace $('#ta-search-user-for-mention').data().search, el
    current_editor.setContent
      html: html
    redactor_objects.app.caret.set($('.ta-user-mention.ta-user-id-'+$(@).data().id), 'end')
    $('#ta-search-user-for-mention').addClass('hidden')
    $('#ta-search-user-for-mention').empty()

  # Lightbox - https://lokeshdhakar.com/projects/lightbox2/
  if $('body.single-topic').length > 0
    $('.ta-topic .content picture').each ->
      link = $(@).find('a')
      img = $(@).find('img')
      if img.length > 0
        split_src = img.attr('src').split('/')
        file_name = split_src[split_src.length-1]
        if link.length == 0
          img.wrap('<a href="'+img.attr('src')+'" data-lightbox="topic-picture">')
        else
          link = $(@).find('a')
          if link.attr('href') == img.attr('src')
            link.attr('data-lightbox', 'topic-picture')

    $('.ta-topic .content figure').each ->
      link = $(@).find('a')
      img = $(@).find('img')
      if img.length > 0
        split_src = img.attr('src').split('/')
        file_name = split_src[split_src.length-1]
        if link.length == 0
          img.wrap('<a href="'+img.attr('src')+'" data-lightbox="topic-picture">')
        else
          link = $(@).find('a')
          if link.attr('href') == img.attr('src')
            link.attr('data-lightbox', 'topic-picture')

    LightboxMaxWidth = $(window).width()-40
    LightboxMaxWidth = 1200 if LightboxMaxWidth > 1200
    lightbox.option({
      'positionFromTop': 20,
      'maxWidth': LightboxMaxWidth,
      'maxHeight': $(window).height()-80,
    })

    setTimeout ->
      $('.lb-dataContainer').each ->
        $(@).parent().prepend($(@))
    , 500

  # Chiudo la navigazione di un corso
  $('.learndash_navigation_lesson_topics_list .list_arrow.expand').each ->
    $(@).trigger('click')

# Nuova form commenti che passa da DEMO
$ ->
  if $('#demo_commentform[data-comment-sent="yes"]').length > 0
    alert('Commento inviato con successo! A breve comparirà sulla pagina.')
    url = remove_params_from_url(window.location.href, ['comment-sent'])
    document.location = url

  arr_phone1 = ["", ".", '390000000000', "000000000", "0000000000", "0000000000000", "1111", "11111", "111111111", "123123123", "123", "1234", "12345", "123456", "1234567", "123456778", "12345678", "123456789", "1234567890", "1234567899", "123456798", "222222222", "1234567891", "1324343123", "1787012", "213123123", "2323232323", "234234", "23456789", "39", "+39", "3213213213"]
  arr_phone2 = []
  $.each arr_phone1, (i,fmp)->
    arr_phone2.push "39"+fmp if $.inArray(fmp, ["",".","+39"]) == -1
  fake_mobile_phones = $.unique($.merge(arr_phone1,arr_phone2))

  $('#demo_commentform .field.required input').on 'change', ->
    phone_rg = /\+*([0-9\/\-\.\s]+){5,}/
    email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
    _val = $(@).val()
    if ($(@).attr('id') == 'email' and not email_rg.test(_val)) or ($(@).attr('id') == 'mobile_phone' and (not phone_rg.test(_val) or $.inArray(_val, fake_mobile_phones) >= 0)) or _val == ''
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')

  $('#demo_commentform .field.required textarea').on 'change', ->
    _val = $(@).val()
    if _val == '' or _val == $(@).attr('data-default')
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')
      # if /.*https?:\/\//.test(_val)
      #   $(@).parents('.field').addClass('error')
      #   alert 'Non puoi inserire dei link nel commento!'
      # else
      #   $(@).parents('.field').removeClass('error')

  $('#demo_commentform').on 'submit', (event)->
    $(@).find('.field.required').each ->
      field = $(@).find('input')
      field = $(@).find('textarea') if field.length == 0
      field.trigger('change') if field.length > 0
    if $(@).find('.field.error').length > 0 or $(@).find('#email_confirmation').val() != ''
      event.preventDefault()
      alert 'Compila tutti i campi obbligatori!'
      # if $(@).find('.field.error #comment_content').length > 0 and $(@).find('.field.error #comment_content').val() != ''
      #   if $(@).find('.field.error').length == 1
      #     alert 'Non puoi inserire dei link nel commento!'
      #   else
      #     alert 'Non puoi inserire dei link nel commento!\nCompila tutti i campi obbligatori!'
      # else
      #   alert 'Compila tutti i campi obbligatori!'

  $(document).on 'click', '.ta-reply-comment', (event)->
    event.preventDefault()
    link = $(@)
    reply_box = link.parents('.comment-box').find('.reply-box')
    if reply_box.is(':visible')
      reply_box.addClass('hidden')
    else
      if reply_box.html() == ''
        parent_id = reply_box.parents('.comment').attr('id')
        base_form = $('#respond > #demo_commentform')
        new_form = base_form.clone()
        if new_form.find('input[name="comment[comment_parent_id]"]').length > 0
          new_form.find('input[name="comment[comment_parent_id]"]').val(link.data().id)
        else
          new_form.prepend("<input type=\"hidden\" name=\"comment[comment_parent_id]\" value=\""+link.data().id+"\">")
        # new_form.find('.socialv-check').remove()
        new_form.find('input[type="submit"]').val('Rispondi')
        new_form.find('textarea').val('')
        new_form.find('textarea').attr('id', "comment_content_"+link.data().id)
        new_form.find('.rx-container').remove()
        reply_box.append(new_form)
        window.init_redactorx("#"+parent_id)
        reply_box.find('.rx-button-topbar[data-name="savebtn"] .rx-button-icon span').text('Rispondi')
      reply_box.removeClass('hidden')
      $('html, body').scrollTop(reply_box.offset().top-66)
# Fine nuova form commenti che passa da DEMO

$(window).on 'resize', ->
  # stickyFooter()
  check_user_menu()
  fixGridColumns()
  if $(window).width() > 600
    $('header#default-header').removeClass('open-search')
    $('header .dropdown-notifications .dropdown-toggle').removeClass('selected')
    $('header .dropdown-profile .dropdown-toggle').removeClass('selected')
  if $('body.in-canvas-app').length == 0 and $('body.ta-mobile-device').length == 0
    $('#navbarSupportedContent #hot-topics').addClass('hidden')
    $('#header-search-form').removeClass('hot-topics-opened')

$(document).on 'click', (event)->
  target = event.target
  # Nascondere box di condivisione
  if $('.share-box').is(':visible') and not $(target).hasClass('share-link') and $(target).parents('.share-link').length == 0
    $('.share-box').addClass('hidden')
  # Nascondere header-menu
  if $('#header-menu-content .header-menu').is(':visible') and $(target).attr('id') != 'header-menu-content' and $(target).parents('#header-menu-content').length == 0
    $('#header-menu-content > .btn').removeClass('selected')
  # Nascondere menu utente mobile
  if $('#top-user .info.mobile').length > 0 and $(target).parents('.menu').length == 0 and not $(target).hasClass('menu-mobile')
    $('#top-user .info .menu-mobile').removeClass('open')
  # Nascondere il menu utente
  if $('.socialv-header-right > ul.list-main-parent .header-login .dropdown-menu.show').length > 0 and $(target).parents('.dropdown-profile-ta').length == 0
    $('.socialv-header-right > ul.list-main-parent .header-login .dropdown-menu.show').prev().removeClass('show selected')
    $('.socialv-header-right > ul.list-main-parent .header-login .dropdown-menu.show').removeClass('show')
  # Nascondere il menu a sinistra
  if $('header #header-left-menu-content .left-menu.show').length > 0 and $(target).parents('.left-menu').length == 0 and $(target).attr('id') != 'left-menu-link' and $(target).parents('#left-menu-link').length == 0
    $('header #header-left-menu-content .left-menu.show').removeClass('show')
  # Tolgo le classi selected sui bottoni con menù nell'header su mobile
  if $(window).width() < 601
    # Bottone notifiche
    if $('header .dropdown-notifications .dropdown-menu').is(':visible') and $(target).parents('.dropdown-notifications').length == 0
      $('header .dropdown-notifications .dropdown-toggle').removeClass('selected')
    # Bottone profilo
    if $('header .dropdown-profile .dropdown-menu').is(':visible') and $(target).parents('.dropdown-profile').length == 0
      $('header .dropdown-profile .dropdown-toggle').removeClass('selected')
  # Nascodere il sottomenu dei corsi
  if $('#menu-courses li.active').length > 0 and $(target).parents('li.active').length == 0
    $('#menu-courses li.active').removeClass('active')
  # Nascodere il sottomenu delle notifiche
  if $('#top-user .info .menu li a.active').length > 0 and not $(target).hasClass('active') and $(target).parents('.active').length == 0
    $('#top-user .info .menu li a.active').removeClass('active')
  # Nascondere il box hot-topics
  if $('#navbarSupportedContent #hot-topics:visible') and $(target).parents('#hot-topics').length == 0 and $(target).attr('id') != 'hot-topics' and $(target).parents('#navbarSupportedContent').length == 0
    $('#navbarSupportedContent #hot-topics').addClass('hidden')
    $('#header-search-form').removeClass('hot-topics-opened')
  # Nascondere box menzioni
  if $('#ta-search-user-for-mention').is(':visible') and $(target).parents('#ta-search-user-for-mention').length == 0
    $('#ta-search-user-for-mention').addClass('hidden')
